var _filter, _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6, _clipPath7, _clipPath8, _clipPath9, _clipPath10, _clipPath11, _clipPath12, _clipPath13, _clipPath14, _clipPath15, _clipPath16, _clipPath17, _clipPath18, _clipPath19, _clipPath20, _clipPath21, _clipPath22, _clipPath23, _clipPath24, _clipPath25, _clipPath26, _clipPath27, _clipPath28, _clipPath29, _clipPath30, _clipPath31, _clipPath32, _clipPath33, _clipPath34, _clipPath35, _clipPath36, _clipPath37, _clipPath38, _clipPath39, _clipPath40, _clipPath41, _clipPath42, _clipPath43, _clipPath44, _clipPath45, _clipPath46, _clipPath47, _clipPath48, _clipPath49, _clipPath50, _clipPath51, _clipPath52, _clipPath53, _clipPath54, _clipPath55, _clipPath56, _clipPath57, _clipPath58, _clipPath59, _clipPath60, _clipPath61, _clipPath62, _clipPath63, _clipPath64, _clipPath65, _clipPath66, _clipPath67, _clipPath68, _clipPath69, _clipPath70, _clipPath71, _clipPath72, _clipPath73, _clipPath74, _clipPath75, _clipPath76, _clipPath77, _clipPath78, _clipPath79, _clipPath80, _clipPath81, _clipPath82, _clipPath83, _clipPath84, _clipPath85, _clipPath86, _clipPath87, _clipPath88, _clipPath89, _clipPath90, _clipPath91, _clipPath92, _clipPath93, _clipPath94, _clipPath95, _clipPath96, _clipPath97, _clipPath98, _clipPath99, _clipPath100, _clipPath101, _clipPath102, _clipPath103, _clipPath104, _clipPath105, _clipPath106, _clipPath107, _clipPath108, _clipPath109, _clipPath110, _clipPath111, _clipPath112, _clipPath113, _clipPath114, _clipPath115, _clipPath116, _clipPath117, _clipPath118, _clipPath119, _clipPath120, _clipPath121, _clipPath122, _clipPath123, _clipPath124, _clipPath125, _clipPath126, _clipPath127, _clipPath128, _clipPath129, _clipPath130, _clipPath131, _clipPath132, _clipPath133, _clipPath134, _clipPath135, _clipPath136, _clipPath137, _clipPath138, _clipPath139, _clipPath140, _clipPath141, _clipPath142, _clipPath143, _clipPath144, _clipPath145, _clipPath146, _clipPath147, _clipPath148, _clipPath149, _clipPath150, _clipPath151, _clipPath152, _clipPath153, _clipPath154, _clipPath155, _clipPath156, _clipPath157, _clipPath158, _clipPath159, _clipPath160, _clipPath161, _clipPath162, _clipPath163, _clipPath164, _clipPath165, _clipPath166, _clipPath167, _clipPath168, _clipPath169, _clipPath170, _clipPath171, _clipPath172, _clipPath173, _clipPath174, _clipPath175, _clipPath176, _clipPath177, _clipPath178, _clipPath179, _clipPath180, _clipPath181, _clipPath182, _clipPath183, _clipPath184, _clipPath185, _clipPath186, _clipPath187, _clipPath188, _clipPath189, _clipPath190, _clipPath191, _clipPath192, _clipPath193, _clipPath194, _clipPath195, _clipPath196, _clipPath197, _clipPath198, _clipPath199, _clipPath200, _clipPath201, _clipPath202, _clipPath203, _clipPath204, _clipPath205, _clipPath206, _clipPath207, _clipPath208, _clipPath209, _clipPath210, _clipPath211, _clipPath212, _clipPath213, _clipPath214, _clipPath215, _clipPath216, _clipPath217, _clipPath218, _clipPath219, _clipPath220, _clipPath221, _clipPath222, _clipPath223, _clipPath224, _clipPath225, _clipPath226, _clipPath227, _clipPath228, _clipPath229, _clipPath230, _clipPath231, _clipPath232, _clipPath233, _clipPath234, _clipPath235, _clipPath236, _clipPath237, _clipPath238, _clipPath239, _clipPath240, _clipPath241, _clipPath242, _clipPath243, _clipPath244, _clipPath245, _clipPath246, _clipPath247, _clipPath248, _clipPath249, _clipPath250, _clipPath251, _clipPath252, _clipPath253, _clipPath254, _clipPath255, _clipPath256, _clipPath257, _clipPath258, _clipPath259, _clipPath260, _clipPath261, _clipPath262, _clipPath263, _clipPath264, _clipPath265, _clipPath266, _clipPath267, _clipPath268, _clipPath269, _clipPath270, _clipPath271, _clipPath272, _clipPath273, _clipPath274, _clipPath275, _clipPath276, _clipPath277, _clipPath278, _clipPath279, _clipPath280, _clipPath281, _clipPath282, _clipPath283, _clipPath284, _clipPath285, _clipPath286, _clipPath287, _clipPath288, _clipPath289, _clipPath290, _clipPath291, _clipPath292, _clipPath293, _clipPath294, _clipPath295, _clipPath296, _clipPath297, _clipPath298, _clipPath299, _clipPath300, _clipPath301, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27, _use28, _use29, _use30, _use31, _use32, _use33, _use34, _use35, _use36, _use37, _use38, _use39, _use40, _use41, _use42, _use43, _use44, _use45, _use46, _use47, _use48, _use49, _use50, _use51, _use52, _use53, _use54, _use55, _use56, _use57, _use58, _use59, _use60, _use61, _use62, _use63, _use64, _use65, _use66, _use67, _use68, _use69, _use70, _use71, _use72, _use73, _use74, _use75, _use76, _use77, _use78, _use79, _use80, _use81, _use82, _use83, _use84, _use85, _use86, _use87, _use88, _use89, _use90, _use91, _use92, _use93, _use94, _use95, _use96, _use97, _use98, _use99, _use100, _use101, _use102, _use103, _use104, _use105, _use106, _use107, _use108, _use109, _use110, _use111, _use112, _use113, _use114, _use115, _use116, _use117, _use118, _use119, _use120, _use121, _use122, _use123, _use124, _use125, _use126, _use127, _use128, _use129, _use130, _use131, _use132, _use133, _use134, _use135, _use136, _use137, _use138, _use139, _use140, _use141, _use142, _use143, _use144, _use145, _use146, _use147, _use148, _use149, _use150, _use151, _use152, _use153, _use154, _use155, _use156, _use157, _use158, _use159, _use160, _use161, _use162, _use163, _use164, _use165, _use166, _use167, _use168, _use169, _use170, _use171, _use172, _use173, _use174, _use175, _use176, _use177, _use178, _use179, _use180, _use181, _use182, _use183, _use184, _use185, _use186, _use187, _use188, _use189, _use190, _use191, _use192, _use193, _use194, _use195, _use196, _use197, _use198, _use199, _use200, _use201, _use202, _use203, _use204, _use205, _use206, _use207, _use208, _use209, _use210, _use211, _use212, _use213, _use214, _use215, _use216, _use217, _use218, _use219, _use220, _use221, _use222, _use223, _use224, _use225, _use226, _use227, _use228, _use229, _use230, _use231, _use232, _use233, _use234, _use235, _use236, _use237, _use238, _use239, _use240, _use241, _use242, _use243, _use244, _use245, _use246, _use247, _use248, _use249, _use250, _use251, _use252, _use253, _use254, _use255, _use256, _use257, _use258, _use259, _use260, _use261, _use262, _use263, _use264, _use265, _use266, _use267, _use268, _use269, _use270, _use271, _use272, _use273, _use274, _use275, _use276, _use277, _use278, _use279, _use280, _use281, _use282, _use283, _use284, _use285, _use286, _use287, _use288, _use289, _use290, _use291, _use292, _use293, _use294, _use295, _use296, _use297, _use298, _use299, _use300, _use301;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "70px",
    height: "48px",
    viewBox: "0 0 69 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    in: "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface7",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 78.518852 7.014404 L 83.995867 7.505859 L 78.518852 7.997314 Z M 78.518852 7.014404 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface10",
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 103.479676 7.014404 L 109.001585 7.505859 L 103.479676 7.997314 Z M 103.479676 7.014404 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface13",
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 73.490772 7.997314 L 76.004812 8.48877 L 73.490772 8.980225 Z M 73.490772 7.997314 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface16",
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 113.490942 7.997314 L 116.99264 8.48877 L 113.490942 8.980225 Z M 113.490942 7.997314 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface19",
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 68.507586 8.980225 L 71.021626 9.516357 L 68.507586 10.007812 Z M 68.507586 8.980225 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface22",
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 119.50668 8.980225 L 122.02072 9.516357 L 119.50668 10.007812 Z M 119.50668 8.980225 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath7 || (_clipPath7 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface25",
    clipPath: "url(#clip7)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 123.502208 10.007812 L 126.016248 10.499268 L 123.502208 10.990723 Z M 123.502208 10.007812 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath8 || (_clipPath8 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface28",
    clipPath: "url(#clip8)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 738.499207 10.007812 L 738.993037 61.52124 L 738.005378 61.52124 Z M 738.499207 10.007812 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath9 || (_clipPath9 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface31",
    clipPath: "url(#clip9)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 127.497736 10.990723 L 130.011775 11.482178 L 127.497736 12.018311 Z M 127.497736 10.990723 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath10 || (_clipPath10 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface34",
    clipPath: "url(#clip10)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 733.516021 10.990723 L 734.997509 11.482178 L 731.495811 13.001221 L 731.495811 12.018311 Z M 733.516021 10.990723 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath11 || (_clipPath11 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface37",
    clipPath: "url(#clip11)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 56.521003 13.001221 L 58.002491 13.492676 L 47.497396 18.988037 L 48.485054 17.022217 Z M 56.521003 13.001221 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath12 || (_clipPath12 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface40",
    clipPath: "url(#clip12)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 134.501132 13.001221 L 138.002831 14.520264 L 136.521343 15.011719 Z M 134.501132 13.001221 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask12"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath13 || (_clipPath13 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface43",
    clipPath: "url(#clip13)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 728.487942 13.001221 L 730.014323 13.492676 L 726.512625 15.011719 L 726.512625 13.984131 Z M 728.487942 13.001221 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask13"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath14 || (_clipPath14 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface46",
    clipPath: "url(#clip14)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 139.484318 15.011719 L 142.986017 16.486084 L 141.504529 17.022217 Z M 139.484318 15.011719 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask14"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath15 || (_clipPath15 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface49",
    clipPath: "url(#clip15)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 723.504755 15.011719 L 724.986243 15.503174 L 721.484545 17.022217 L 721.484545 15.994629 Z M 723.504755 15.011719 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask15"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath16 || (_clipPath16 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface52",
    clipPath: "url(#clip16)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 718.521569 17.022217 L 720.003057 17.513672 L 716.501359 18.988037 L 716.501359 18.005127 Z M 718.521569 17.022217 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask16"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath17 || (_clipPath17 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface55",
    clipPath: "url(#clip17)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 45.522079 18.988037 L 44.489527 20.998535 Z M 45.522079 18.988037 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask17"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath18 || (_clipPath18 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface58",
    clipPath: "url(#clip18)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 42.51421 20.998535 L 40.493999 23.991943 Z M 42.51421 20.998535 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask18"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath19 || (_clipPath19 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface61",
    clipPath: "url(#clip19)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 154.47877 21.981445 L 157.980469 24.483398 L 156.498981 23.991943 Z M 154.47877 21.981445 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask19"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath20 || (_clipPath20 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface64",
    clipPath: "url(#clip20)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 706.490093 21.981445 L 708.016474 22.517578 L 704.514776 23.991943 L 704.514776 23.009033 Z M 706.490093 21.981445 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask20"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath21 || (_clipPath21 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface67",
    clipPath: "url(#clip21)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 38.518682 23.991943 L 32.009115 31.497803 L 28.507416 36.010254 L 31.021456 32.480713 Z M 38.518682 23.991943 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask21"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath22 || (_clipPath22 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface70",
    clipPath: "url(#clip22)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 701.506907 23.991943 L 702.988394 24.483398 L 699.486696 26.002441 L 699.486696 25.019531 Z M 701.506907 23.991943 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask22"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath23 || (_clipPath23 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip23"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface73",
    clipPath: "url(#clip23)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 159.50685 25.019531 L 163.996207 28.504395 L 161.482167 26.985352 Z M 159.50685 25.019531 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask23"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath24 || (_clipPath24 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip24"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface76",
    clipPath: "url(#clip24)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 696.478827 26.002441 L 698.005208 26.493896 L 695.984998 26.985352 L 695.491168 62.012695 L 694.997339 27.521484 Z M 696.478827 26.002441 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask24"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath25 || (_clipPath25 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip25"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface79",
    clipPath: "url(#clip25)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 165.477695 28.99585 L 171.987262 34.491211 L 168.485564 31.989258 Z M 165.477695 28.99585 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath26 || (_clipPath26 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip26"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface82",
    clipPath: "url(#clip26)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 173.513644 34.982666 L 174.007473 36.501709 L 171.987262 37.484619 Z M 173.513644 34.982666 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask26"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath27 || (_clipPath27 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip27"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface85",
    clipPath: "url(#clip27)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 27.519758 36.993164 L 26.981035 38.512207 L 25.499547 41.01416 L 25.993376 39.495117 Z M 27.519758 36.993164 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask27"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath28 || (_clipPath28 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip28"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface88",
    clipPath: "url(#clip28)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 171.493433 39.003662 L 170.011945 41.505615 L 167.497905 44.990479 L 168.979393 42.488525 Z M 171.493433 39.003662 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask28"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath29 || (_clipPath29 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip29"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface91",
    clipPath: "url(#clip29)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 83.502038 46.018066 L 87.991395 46.509521 L 83.502038 47.000977 Z M 83.502038 46.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask29"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath30 || (_clipPath30 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip30"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface94",
    clipPath: "url(#clip30)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 96.521173 46.018066 L 101.998188 46.509521 L 96.521173 47.000977 Z M 96.521173 46.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask30"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath31 || (_clipPath31 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface97",
    clipPath: "url(#clip31)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 166.510247 46.018066 L 164.983865 48.52002 L 162.514719 52.004883 L 163.996207 49.50293 Z M 166.510247 46.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask31"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath32 || (_clipPath32 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface100",
    clipPath: "url(#clip32)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 78.518852 47.000977 L 80.987998 47.492432 L 78.518852 47.983887 Z M 78.518852 47.000977 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask32"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath33 || (_clipPath33 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip33"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface103",
    clipPath: "url(#clip33)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 104.512228 47.000977 L 108.013927 47.492432 L 104.512228 47.983887 Z M 104.512228 47.000977 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask33"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath34 || (_clipPath34 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface106",
    clipPath: "url(#clip34)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 75.510983 47.983887 L 76.992471 48.52002 C 71.739923 50.217773 67.564821 53.077148 64.512058 57.008789 L 68.507586 52.004883 Z M 75.510983 47.983887 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask34"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath35 || (_clipPath35 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip35"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface109",
    clipPath: "url(#clip35)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 109.495414 47.983887 L 112.009454 48.52002 L 109.495414 49.011475 Z M 109.495414 47.983887 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask35"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath36 || (_clipPath36 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface112",
    clipPath: "url(#clip36)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 121.481997 52.004883 L 124.983696 53.479248 L 123.502208 54.015381 Z M 121.481997 52.004883 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask36"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath37 || (_clipPath37 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface115",
    clipPath: "url(#clip37)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 161.482167 52.987793 L 160.000679 55.489746 L 157.486639 59.019287 L 159.013021 56.517334 Z M 161.482167 52.987793 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask37"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath38 || (_clipPath38 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip38"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface118",
    clipPath: "url(#clip38)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 19.483809 54.015381 L 19.977638 56.517334 L 18.98998 56.517334 Z M 19.483809 54.015381 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask38"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath39 || (_clipPath39 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip39"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface121",
    clipPath: "url(#clip39)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 130.505605 55.981201 L 135.98262 59.510742 L 134.501132 59.019287 C 131.852412 58.661865 130.505605 57.678955 130.505605 55.981201 Z M 130.505605 55.981201 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask39"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath40 || (_clipPath40 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip40"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface124",
    clipPath: "url(#clip40)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 18.49615 57.991699 L 18.98998 61.52124 L 18.002321 61.52124 Z M 18.49615 57.991699 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask40"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath41 || (_clipPath41 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip41"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface127",
    clipPath: "url(#clip41)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 63.479506 57.991699 L 62.985677 59.510742 L 62.491848 60.985107 L 61.998019 59.510742 Z M 63.479506 57.991699 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask41"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath42 || (_clipPath42 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface130",
    clipPath: "url(#clip42)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 264.512908 57.991699 L 280.001189 58.483154 L 264.512908 59.019287 Z M 264.512908 57.991699 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask42"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath43 || (_clipPath43 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip43"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface133",
    clipPath: "url(#clip43)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 414.502321 57.991699 L 429.002944 58.483154 L 414.502321 59.019287 Z M 414.502321 57.991699 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask43"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath44 || (_clipPath44 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip44"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface136",
    clipPath: "url(#clip44)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 256.521852 59.019287 L 259.978657 59.510742 L 256.521852 60.002197 Z M 256.521852 59.019287 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask44"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath45 || (_clipPath45 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip45"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface139",
    clipPath: "url(#clip45)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 284.490546 59.019287 L 288.979903 59.510742 L 284.490546 60.002197 Z M 284.490546 59.019287 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask45"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath46 || (_clipPath46 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip46"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface142",
    clipPath: "url(#clip46)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 406.511266 59.019287 L 410.012964 59.510742 L 406.511266 60.002197 Z M 406.511266 59.019287 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask46"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath47 || (_clipPath47 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip47"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface145",
    clipPath: "url(#clip47)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 434.479959 59.019287 L 437.981658 59.510742 L 434.479959 60.002197 Z M 434.479959 59.019287 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask47"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath48 || (_clipPath48 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip48"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface148",
    clipPath: "url(#clip48)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 137.509001 60.002197 L 148.014096 67.508057 L 145.500057 65.989014 L 138.49666 62.012695 Z M 137.509001 60.002197 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask48"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath49 || (_clipPath49 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip49"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface151",
    clipPath: "url(#clip49)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 156.498981 60.002197 L 155.017493 62.50415 L 150.483243 68.982422 L 149.001755 68.490967 L 152.009624 66.480469 Z M 156.498981 60.002197 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask49"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath50 || (_clipPath50 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip50"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface154",
    clipPath: "url(#clip50)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 251.493773 60.002197 L 254.007812 60.493652 L 251.493773 60.985107 Z M 251.493773 60.002197 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask50"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath51 || (_clipPath51 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip51"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface157",
    clipPath: "url(#clip51)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 291.493942 60.002197 L 294.007982 60.493652 L 291.493942 60.985107 Z M 291.493942 60.002197 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask51"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath52 || (_clipPath52 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip52"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface160",
    clipPath: "url(#clip52)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 401.483186 60.002197 L 403.997226 60.493652 L 401.483186 60.985107 Z M 401.483186 60.002197 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask52"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath53 || (_clipPath53 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip53"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface163",
    clipPath: "url(#clip53)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 440.495697 60.002197 L 443.009737 60.493652 L 440.495697 60.985107 Z M 440.495697 60.002197 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask53"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath54 || (_clipPath54 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip54"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface166",
    clipPath: "url(#clip54)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 243.502717 62.012695 L 246.016757 62.50415 L 241.482507 63.978516 L 241.482507 62.995605 Z M 243.502717 62.012695 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask54"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath55 || (_clipPath55 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip55"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface169",
    clipPath: "url(#clip55)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 299.484998 62.012695 L 306.982224 64.514648 L 305.500736 65.006104 L 299.484998 62.995605 Z M 299.484998 62.012695 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask55"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath56 || (_clipPath56 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip56"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface172",
    clipPath: "url(#clip56)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 393.492131 62.012695 L 396.006171 62.50415 L 393.492131 62.995605 Z M 393.492131 62.012695 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask56"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath57 || (_clipPath57 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip57"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface175",
    clipPath: "url(#clip57)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 448.486753 62.012695 L 455.983979 64.514648 L 454.502491 65.006104 L 448.486753 62.995605 Z M 448.486753 62.012695 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask57"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath58 || (_clipPath58 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip58"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface178",
    clipPath: "url(#clip58)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 517.488168 62.012695 L 517.981997 176.521729 L 516.994339 176.521729 Z M 517.488168 62.012695 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask58"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath59 || (_clipPath59 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip59"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface181",
    clipPath: "url(#clip59)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 560.496207 62.012695 L 560.990036 161.51001 L 560.002378 161.51001 Z M 560.496207 62.012695 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask59"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath60 || (_clipPath60 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip60"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface184",
    clipPath: "url(#clip60)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 623.481884 62.012695 L 624.020607 160.482422 L 622.988055 160.482422 Z M 623.481884 62.012695 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask60"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath61 || (_clipPath61 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip61"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface187",
    clipPath: "url(#clip61)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 666.489923 62.012695 L 666.983752 227.990479 L 622.988055 227.990479 L 622.988055 211.504395 L 615.984658 216.508301 L 624.020607 209.493896 L 624.020607 227.007568 L 665.996094 227.007568 Z M 666.489923 62.012695 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask61"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath62 || (_clipPath62 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip62"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface190",
    clipPath: "url(#clip62)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 781.507246 62.012695 L 782.001076 99.98877 L 738.993037 99.98877 L 738.993037 178.487549 L 738.005378 178.487549 L 738.005378 100.480225 L 739.486866 99.005859 L 781.013417 99.005859 Z M 781.507246 62.012695 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask62"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath63 || (_clipPath63 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface193",
    clipPath: "url(#clip63)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 390.484262 62.995605 L 392.010643 63.487061 L 388.508945 65.006104 L 388.508945 63.978516 Z M 390.484262 62.995605 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask63"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath64 || (_clipPath64 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip64"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface196",
    clipPath: "url(#clip64)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 385.501076 65.006104 L 386.982563 65.497559 L 371.494282 73.986328 L 372.481941 72.020508 Z M 385.501076 65.006104 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask64"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath65 || (_clipPath65 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip65"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface199",
    clipPath: "url(#clip65)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 457.51036 65.006104 L 468.015455 70.501465 L 466.489074 70.01001 L 457.51036 65.989014 Z M 457.51036 65.006104 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask65"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath66 || (_clipPath66 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip66"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface202",
    clipPath: "url(#clip66)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 17.508492 65.989014 L 18.002321 77.515869 L 17.014663 77.515869 Z M 17.508492 65.989014 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask66"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath67 || (_clipPath67 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip67"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface205",
    clipPath: "url(#clip67)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 60.516531 65.989014 L 61.01036 69.518555 L 59.977808 69.518555 Z M 60.516531 65.989014 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask67"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath68 || (_clipPath68 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip68"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface208",
    clipPath: "url(#clip68)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 233.491452 65.989014 L 235.017833 66.480469 L 230.483582 68.982422 L 231.516135 67.016602 Z M 233.491452 65.989014 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask68"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath69 || (_clipPath69 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip69"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface211",
    clipPath: "url(#clip69)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 314.47945 67.999512 L 317.981148 70.501465 L 316.49966 70.01001 Z M 314.47945 67.999512 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask69"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath70 || (_clipPath70 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip70"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface214",
    clipPath: "url(#clip70)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 226.488055 70.01001 L 225.500396 72.020508 L 219.484658 75.996826 L 221.504869 73.003418 Z M 226.488055 70.01001 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask70"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath71 || (_clipPath71 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip71"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface217",
    clipPath: "url(#clip71)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 319.507529 70.99292 L 320.495188 73.003418 Z M 319.507529 70.99292 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask71"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath72 || (_clipPath72 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip72"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface220",
    clipPath: "url(#clip72)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 469.496943 70.99292 C 478.026721 75.862793 485.209692 82.02832 491.000962 89.489502 L 478.52055 78.007324 L 470.484601 73.003418 Z M 469.496943 70.99292 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask72"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath73 || (_clipPath73 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip73"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface223",
    clipPath: "url(#clip73)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 322.515399 73.003418 L 324.490716 75.996826 Z M 322.515399 73.003418 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask73"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath74 || (_clipPath74 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip74"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface226",
    clipPath: "url(#clip74)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 369.518965 73.986328 L 367.498755 76.979736 Z M 369.518965 73.986328 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask74"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath75 || (_clipPath75 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip75"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface229",
    clipPath: "url(#clip75)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 217.509341 75.996826 L 213.513813 81.000732 Z M 217.509341 75.996826 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask75"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath76 || (_clipPath76 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip76"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface232",
    clipPath: "url(#clip76)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 326.510926 75.996826 L 331.494112 81.983643 Z M 326.510926 75.996826 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask76"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath77 || (_clipPath77 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip77"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface235",
    clipPath: "url(#clip77)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 62.491848 76.979736 L 65.005888 80.509277 L 61.998019 78.498779 Z M 62.491848 76.979736 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask77"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath78 || (_clipPath78 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip78"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface238",
    clipPath: "url(#clip78)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 365.478544 76.979736 L 352.010473 91.5 L 345.500906 101.016357 L 345.994735 99.497314 C 350.888134 90.383057 357.352808 82.877197 365.478544 76.979736 Z M 365.478544 76.979736 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask78"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath79 || (_clipPath79 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip79"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface241",
    clipPath: "url(#clip79)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 211.493603 81.000732 L 207.498075 86.004639 Z M 211.493603 81.000732 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask79"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath80 || (_clipPath80 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip80"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface244",
    clipPath: "url(#clip80)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 18.49615 81.983643 L 18.98998 85.513184 L 18.002321 85.513184 Z M 18.49615 81.983643 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask80"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath81 || (_clipPath81 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip81"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface247",
    clipPath: "url(#clip81)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 333.514323 81.983643 L 338.991338 88.506592 L 334.995811 85.513184 Z M 333.514323 81.983643 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask81"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath82 || (_clipPath82 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip82"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface250",
    clipPath: "url(#clip82)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 67.519928 83.01123 L 69.495245 86.004639 Z M 67.519928 83.01123 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask82"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath83 || (_clipPath83 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip83"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface253",
    clipPath: "url(#clip83)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 206.510417 86.987549 L 203.008718 91.5 L 200.494678 94.984863 L 202.02106 92.48291 Z M 206.510417 86.987549 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask83"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath84 || (_clipPath84 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip84"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface256",
    clipPath: "url(#clip84)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 19.483809 88.015137 L 19.977638 90.51709 L 18.98998 90.51709 Z M 19.483809 88.015137 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask84"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath85 || (_clipPath85 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip85"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface259",
    clipPath: "url(#clip85)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 77.4863 88.998047 L 80.987998 90.51709 L 79.50651 91.008545 Z M 77.4863 88.998047 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask85"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath86 || (_clipPath86 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface262",
    clipPath: "url(#clip86)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 338.497509 89.980957 L 327.004755 102.490723 L 314.47945 115.983398 L 326.017097 103.518311 Z M 338.497509 89.980957 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask86"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath87 || (_clipPath87 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip87"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface265",
    clipPath: "url(#clip87)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 491.494792 91.008545 L 493.515002 94.001953 Z M 491.494792 91.008545 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask87"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath88 || (_clipPath88 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip88"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface268",
    clipPath: "url(#clip88)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 91.493093 94.001953 L 94.007133 94.493408 L 91.493093 94.984863 Z M 91.493093 94.001953 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask88"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath89 || (_clipPath89 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip89"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface271",
    clipPath: "url(#clip89)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 21.504019 94.984863 L 25.993376 103.518311 L 24.018059 102.490723 Z M 21.504019 94.984863 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask89"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath90 || (_clipPath90 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip90"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface274",
    clipPath: "url(#clip90)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 494.502661 94.984863 L 498.004359 99.497314 L 495.984149 98.514404 Z M 494.502661 94.984863 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask90"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath91 || (_clipPath91 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip91"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface277",
    clipPath: "url(#clip91)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 98.49649 96.012451 L 101.01053 96.503906 L 98.49649 96.995361 Z M 98.49649 96.012451 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask91"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath92 || (_clipPath92 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip92"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface280",
    clipPath: "url(#clip92)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 199.50702 96.012451 L 198.519361 97.978271 Z M 199.50702 96.012451 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask92"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath93 || (_clipPath93 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip93"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface283",
    clipPath: "url(#clip93)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 102.492018 96.995361 L 105.006058 97.486816 L 102.492018 97.978271 Z M 102.492018 96.995361 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask93"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath94 || (_clipPath94 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip94"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface286",
    clipPath: "url(#clip94)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 262.492697 96.995361 L 265.006737 97.486816 L 262.492697 97.978271 Z M 262.492697 96.995361 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask94"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath95 || (_clipPath95 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip95"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface289",
    clipPath: "url(#clip95)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 277.487149 96.995361 L 280.988847 97.486816 L 277.487149 97.978271 Z M 277.487149 96.995361 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask95"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath96 || (_clipPath96 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip96"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface292",
    clipPath: "url(#clip96)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 411.494452 96.995361 L 414.99615 97.486816 L 411.494452 97.978271 Z M 411.494452 96.995361 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask96"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath97 || (_clipPath97 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip97"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface295",
    clipPath: "url(#clip97)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 427.521456 96.995361 L 430.978261 97.486816 L 427.521456 97.978271 Z M 427.521456 96.995361 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask97"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath98 || (_clipPath98 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip98"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface298",
    clipPath: "url(#clip98)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 106.487545 97.978271 L 109.001585 98.514404 L 106.487545 99.005859 Z M 106.487545 97.978271 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask98"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath99 || (_clipPath99 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip99"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface301",
    clipPath: "url(#clip99)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 258.497169 97.978271 L 261.011209 98.514404 L 258.497169 99.005859 Z M 258.497169 97.978271 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask99"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath100 || (_clipPath100 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip100"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface304",
    clipPath: "url(#clip100)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 407.498924 97.978271 L 410.012964 98.514404 L 405.478714 99.98877 L 405.478714 99.005859 Z M 407.498924 97.978271 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask100"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath101 || (_clipPath101 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip101"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface307",
    clipPath: "url(#clip101)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 432.504642 97.978271 L 435.018682 98.514404 L 432.504642 99.005859 Z M 432.504642 97.978271 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask101"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath102 || (_clipPath102 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip102"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface310",
    clipPath: "url(#clip102)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 110.483073 99.005859 L 112.997113 99.497314 L 110.483073 99.98877 Z M 110.483073 99.005859 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask102"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath103 || (_clipPath103 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip103"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface313",
    clipPath: "url(#clip103)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 197.486809 99.005859 L 196.99298 100.480225 L 191.515965 112.00708 L 191.022135 110.488037 Z M 197.486809 99.005859 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask103"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath104 || (_clipPath104 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip104"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface316",
    clipPath: "url(#clip104)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 436.50017 99.005859 L 444.985054 103.518311 L 443.503567 102.982178 L 436.50017 99.98877 Z M 436.50017 99.005859 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask104"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath105 || (_clipPath105 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip105"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface319",
    clipPath: "url(#clip105)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 675.51353 99.005859 L 694.50351 99.005859 L 695.984998 100.480225 L 695.491168 188.986816 L 694.997339 99.98877 L 675.51353 99.98877 Z M 675.51353 99.005859 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask105"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath106 || (_clipPath106 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip106"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface322",
    clipPath: "url(#clip106)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 253.513983 99.98877 L 254.995471 100.480225 L 250.506114 102.982178 L 251.493773 101.016357 Z M 253.513983 99.98877 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask106"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath107 || (_clipPath107 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip107"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface325",
    clipPath: "url(#clip107)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 402.515738 99.98877 L 403.997226 100.480225 L 399.507869 102.982178 L 400.495528 101.016357 Z M 402.515738 99.98877 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask107"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath108 || (_clipPath108 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip108"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface328",
    clipPath: "url(#clip108)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 117.48647 101.016357 L 120.00051 101.507812 L 117.48647 101.999268 Z M 117.48647 101.016357 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask108"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath109 || (_clipPath109 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip109"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface331",
    clipPath: "url(#clip109)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 293.514153 101.999268 L 301.999038 108.522217 L 298.497339 106.020264 C 295.444577 105.216064 293.783514 103.875732 293.514153 101.999268 Z M 293.514153 101.999268 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask109"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath110 || (_clipPath110 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip110"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface334",
    clipPath: "url(#clip110)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 248.485904 102.982178 L 246.510587 106.020264 L 239.013361 112.498535 L 236.499321 115.983398 L 237.980808 113.481445 L 245.478034 104.992676 Z M 248.485904 102.982178 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask110"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath111 || (_clipPath111 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip111"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface337",
    clipPath: "url(#clip111)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 397.487659 102.982178 L 396.5 104.992676 L 391.516814 109.013672 L 395.512341 104.009766 Z M 397.487659 102.982178 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask111"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath112 || (_clipPath112 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip112"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface340",
    clipPath: "url(#clip112)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 499.485847 102.982178 L 502.987545 109.505127 L 501.999887 109.505127 Z M 499.485847 102.982178 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask112"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath113 || (_clipPath113 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip113"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface343",
    clipPath: "url(#clip113)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 343.480695 104.009766 L 342.986866 105.484131 L 342.493037 107.003174 L 341.999207 105.484131 Z M 343.480695 104.009766 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask113"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath114 || (_clipPath114 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip114"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface346",
    clipPath: "url(#clip114)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 446.511436 104.009766 L 448.486753 107.003174 Z M 446.511436 104.009766 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask114"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath115 || (_clipPath115 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip115"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface349",
    clipPath: "url(#clip115)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 26.487206 104.992676 L 36.992301 116.519531 L 28.013587 108.522217 Z M 26.487206 104.992676 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask115"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath116 || (_clipPath116 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip116"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface352",
    clipPath: "url(#clip116)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 136.521343 107.003174 L 139.978148 108.522217 L 138.49666 109.013672 Z M 136.521343 107.003174 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask116"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath117 || (_clipPath117 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip117"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface355",
    clipPath: "url(#clip117)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 450.506963 107.003174 L 459.979506 118.485352 L 458.004189 117.502441 Z M 450.506963 107.003174 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask117"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath118 || (_clipPath118 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip118"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface358",
    clipPath: "url(#clip118)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 303.480525 109.013672 L 311.516474 117.993896 Z M 303.480525 109.013672 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask118"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath119 || (_clipPath119 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip119"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface361",
    clipPath: "url(#clip119)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 143.479846 109.996582 L 149.989413 113.481445 L 148.507926 112.98999 L 143.479846 110.979492 Z M 143.479846 109.996582 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask119"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath120 || (_clipPath120 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip120"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface364",
    clipPath: "url(#clip120)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 388.508945 110.979492 L 385.501076 115.000488 Z M 388.508945 110.979492 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask120"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath121 || (_clipPath121 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip121"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface367",
    clipPath: "url(#clip121)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 503.481375 110.979492 L 505.007756 114.509033 L 504.020097 114.509033 Z M 503.481375 110.979492 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask121"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath122 || (_clipPath122 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip122"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface370",
    clipPath: "url(#clip122)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 339.485168 112.00708 L 339.978997 113.481445 L 336.522192 122.997803 L 335.983469 120.49585 Z M 339.485168 112.00708 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask122"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath123 || (_clipPath123 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip123"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface373",
    clipPath: "url(#clip123)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 151.515795 114.017578 L 160.000679 120.49585 L 156.498981 117.993896 C 153.446218 117.189697 151.785156 115.849365 151.515795 114.017578 Z M 151.515795 114.017578 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask123"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath124 || (_clipPath124 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip124"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface376",
    clipPath: "url(#clip124)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 384.513417 115.983398 L 383.480865 117.993896 Z M 384.513417 115.983398 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask124"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath125 || (_clipPath125 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip125"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface379",
    clipPath: "url(#clip125)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 38.518682 117.010986 L 46.015908 122.506348 L 44.489527 122.014893 C 41.167403 120.987305 39.147192 119.334229 38.518682 117.010986 Z M 38.518682 117.010986 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask125"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath126 || (_clipPath126 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip126"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface382",
    clipPath: "url(#clip126)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 235.511662 117.010986 L 235.017833 118.485352 L 232.503793 123.980713 L 232.009964 122.506348 Z M 235.511662 117.010986 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask126"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath127 || (_clipPath127 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip127"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface385",
    clipPath: "url(#clip127)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 506.489244 119.021484 L 506.983073 121.47876 L 505.995414 121.47876 Z M 506.489244 119.021484 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask127"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath128 || (_clipPath128 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip128"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface388",
    clipPath: "url(#clip128)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 161.482167 120.987305 L 170.011945 130.503662 L 166.016418 127.510254 Z M 161.482167 120.987305 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask128"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath129 || (_clipPath129 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip129"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface391",
    clipPath: "url(#clip129)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 187.520437 122.014893 L 188.014266 124.516846 L 186.981714 124.516846 Z M 187.520437 122.014893 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask129"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath130 || (_clipPath130 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip130"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface394",
    clipPath: "url(#clip130)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 380.517889 122.997803 L 381.011719 124.516846 L 378.497679 130.995117 L 378.00385 128.493164 Z M 380.517889 122.997803 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask130"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath131 || (_clipPath131 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip131"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface397",
    clipPath: "url(#clip131)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 507.521796 122.997803 L 508.015625 125.499756 L 506.983073 125.499756 Z M 507.521796 122.997803 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask131"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath132 || (_clipPath132 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip132"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface400",
    clipPath: "url(#clip132)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 335.48964 123.980713 L 335.983469 126.482666 L 334.995811 126.482666 Z M 335.48964 123.980713 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask132"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath133 || (_clipPath133 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip133"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface403",
    clipPath: "url(#clip133)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 462.493546 123.980713 L 464.019928 127.510254 L 462.987375 127.510254 Z M 462.493546 123.980713 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask133"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath134 || (_clipPath134 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip134"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface406",
    clipPath: "url(#clip134)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 231.516135 125.008301 L 232.009964 126.482666 L 230.483582 130.012207 L 229.989753 127.510254 Z M 231.516135 125.008301 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask134"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath135 || (_clipPath135 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip135"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface409",
    clipPath: "url(#clip135)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 55.488451 127.018799 L 58.990149 128.493164 L 57.508662 128.984619 Z M 55.488451 127.018799 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask135"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath136 || (_clipPath136 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip136"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface412",
    clipPath: "url(#clip136)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 186.487885 127.018799 L 186.981714 129.520752 L 185.994056 129.520752 Z M 186.487885 127.018799 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask136"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath137 || (_clipPath137 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip137"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface415",
    clipPath: "url(#clip137)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 508.509454 127.018799 L 509.003284 130.503662 L 508.015625 130.503662 Z M 508.509454 127.018799 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask137"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath138 || (_clipPath138 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip138"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface418",
    clipPath: "url(#clip138)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 334.501981 128.984619 L 334.995811 132.51416 L 334.008152 132.51416 Z M 334.501981 128.984619 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask138"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath139 || (_clipPath139 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip139"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface421",
    clipPath: "url(#clip139)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 229.495924 130.995117 L 229.989753 133.49707 L 229.002095 133.49707 Z M 229.495924 130.995117 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask139"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath140 || (_clipPath140 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip140"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface424",
    clipPath: "url(#clip140)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 170.505774 131.978027 L 173.019814 135.507568 L 170.999604 134.47998 Z M 170.505774 131.978027 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask140"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath141 || (_clipPath141 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip141"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface427",
    clipPath: "url(#clip141)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 185.500226 131.978027 L 185.994056 137.518066 L 185.006397 137.518066 Z M 185.500226 131.978027 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask141"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath142 || (_clipPath142 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip142"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface430",
    clipPath: "url(#clip142)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 377.51002 131.978027 L 378.00385 135.507568 L 377.016191 135.507568 Z M 377.51002 131.978027 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask142"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath143 || (_clipPath143 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip143"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface433",
    clipPath: "url(#clip143)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 465.501415 133.005615 L 465.995245 135.507568 L 465.007586 135.507568 Z M 465.501415 133.005615 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask143"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath144 || (_clipPath144 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip144"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface436",
    clipPath: "url(#clip144)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 75.510983 133.988525 L 77.980129 134.47998 L 75.510983 135.016113 Z M 75.510983 133.988525 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask144"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath145 || (_clipPath145 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip145"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface439",
    clipPath: "url(#clip145)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 509.497113 133.988525 L 509.990942 142.521973 L 509.003284 142.521973 Z M 509.497113 133.988525 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask145"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath146 || (_clipPath146 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip146"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface442",
    clipPath: "url(#clip146)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 82.51438 135.999023 L 84.983526 136.490479 L 82.51438 136.981934 Z M 82.51438 135.999023 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask146"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath147 || (_clipPath147 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip147"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface445",
    clipPath: "url(#clip147)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 228.508265 135.999023 L 229.002095 140.511475 L 228.014436 140.511475 Z M 228.508265 135.999023 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask147"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath148 || (_clipPath148 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip148"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface448",
    clipPath: "url(#clip148)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 86.509907 136.981934 L 88.979053 137.518066 L 86.509907 138.009521 Z M 86.509907 136.981934 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask148"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath149 || (_clipPath149 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip149"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface451",
    clipPath: "url(#clip149)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 333.514323 136.981934 L 334.008152 153.512695 L 333.020494 153.512695 Z M 333.514323 136.981934 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask149"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath150 || (_clipPath150 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip150"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface454",
    clipPath: "url(#clip150)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 91.493093 138.009521 L 94.007133 138.500977 L 91.493093 138.992432 Z M 91.493093 138.009521 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask150"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath151 || (_clipPath151 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip151"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface457",
    clipPath: "url(#clip151)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 466.489074 138.009521 L 466.982903 151.502197 L 465.995245 151.502197 Z M 466.489074 138.009521 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask151"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath152 || (_clipPath152 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip152"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface460",
    clipPath: "url(#clip152)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 95.488621 138.992432 L 98.002661 139.483887 L 95.488621 140.02002 Z M 95.488621 138.992432 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask152"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath153 || (_clipPath153 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip153"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface463",
    clipPath: "url(#clip153)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 376.522362 138.992432 L 377.016191 149.491699 L 375.983639 149.491699 Z M 376.522362 138.992432 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask153"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath154 || (_clipPath154 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip154"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface466",
    clipPath: "url(#clip154)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 99.484149 140.02002 L 101.998188 140.511475 L 99.484149 141.00293 Z M 99.484149 140.02002 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask154"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath155 || (_clipPath155 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip155"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface469",
    clipPath: "url(#clip155)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 106.487545 141.98584 L 109.001585 142.521973 L 106.487545 143.013428 Z M 106.487545 141.98584 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask155"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath156 || (_clipPath156 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip156"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface472",
    clipPath: "url(#clip156)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 113.490942 143.996338 L 116.99264 145.515381 L 115.511153 146.006836 Z M 113.490942 143.996338 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask156"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath157 || (_clipPath157 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip157"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface475",
    clipPath: "url(#clip157)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 118.519022 146.006836 L 124.983696 149.491699 L 123.502208 149.000244 L 118.519022 146.989746 Z M 118.519022 146.006836 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask157"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath158 || (_clipPath158 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip158"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface478",
    clipPath: "url(#clip158)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 509.497113 146.006836 L 509.990942 154.495605 L 509.003284 154.495605 Z M 509.497113 146.006836 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask158"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath159 || (_clipPath159 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip159"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface481",
    clipPath: "url(#clip159)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 177.509171 146.989746 L 178.003 149.491699 L 177.015342 149.491699 Z M 177.509171 146.989746 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask159"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath160 || (_clipPath160 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip160"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface484",
    clipPath: "url(#clip160)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 228.508265 149.000244 L 229.002095 153.512695 L 228.014436 153.512695 Z M 228.508265 149.000244 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask160"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath161 || (_clipPath161 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip161"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface487",
    clipPath: "url(#clip161)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 126.510077 149.983154 L 127.497736 151.993652 Z M 126.510077 149.983154 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask161"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath162 || (_clipPath162 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip162"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface490",
    clipPath: "url(#clip162)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 129.517946 151.993652 L 132.480922 156.014648 Z M 129.517946 151.993652 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask162"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath163 || (_clipPath163 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip163"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface493",
    clipPath: "url(#clip163)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 178.49683 151.993652 L 178.990659 156.506104 L 178.003 156.506104 Z M 178.49683 151.993652 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask163"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath164 || (_clipPath164 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip164"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface496",
    clipPath: "url(#clip164)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 185.500226 153.02124 L 185.994056 157.489014 L 185.006397 157.489014 Z M 185.500226 153.02124 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask164"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath165 || (_clipPath165 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip165"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface499",
    clipPath: "url(#clip165)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 377.51002 153.02124 L 378.00385 156.506104 L 377.016191 156.506104 Z M 377.51002 153.02124 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask165"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath166 || (_clipPath166 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip166"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface502",
    clipPath: "url(#clip166)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 465.501415 154.987061 L 465.995245 157.489014 L 465.007586 157.489014 Z M 465.501415 154.987061 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask166"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath167 || (_clipPath167 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip167"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface505",
    clipPath: "url(#clip167)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 229.495924 156.014648 L 229.989753 158.516602 L 229.002095 158.516602 Z M 229.495924 156.014648 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask167"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath168 || (_clipPath168 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip168"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface508",
    clipPath: "url(#clip168)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 133.513474 156.997559 L 134.994962 159.499512 L 134.007303 159.499512 Z M 133.513474 156.997559 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask168"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath169 || (_clipPath169 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip169"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface511",
    clipPath: "url(#clip169)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 334.501981 157.980469 L 334.995811 161.51001 L 334.008152 161.51001 Z M 334.501981 157.980469 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask169"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath170 || (_clipPath170 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip170"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface514",
    clipPath: "url(#clip170)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 378.497679 157.980469 L 379.979167 162.49292 L 378.991508 162.49292 Z M 378.497679 157.980469 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask170"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath171 || (_clipPath171 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip171"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface517",
    clipPath: "url(#clip171)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 508.509454 157.980469 L 509.003284 161.51001 L 508.015625 161.51001 Z M 508.509454 157.980469 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask171"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath172 || (_clipPath172 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip172"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface520",
    clipPath: "url(#clip172)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 135.488791 161.018555 L 135.98262 163.520508 L 134.994962 163.520508 Z M 135.488791 161.018555 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask172"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath173 || (_clipPath173 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip173"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface523",
    clipPath: "url(#clip173)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 186.487885 161.018555 L 186.981714 163.520508 L 185.994056 163.520508 Z M 186.487885 161.018555 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask173"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath174 || (_clipPath174 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip174"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface526",
    clipPath: "url(#clip174)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 34.478261 162.001465 L 36.498471 164.994873 L 34.478261 162.984375 L 32.009115 164.503418 Z M 34.478261 162.001465 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask174"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath175 || (_clipPath175 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip175"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface529",
    clipPath: "url(#clip175)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 335.48964 162.984375 L 335.983469 165.486328 L 334.995811 165.486328 Z M 335.48964 162.984375 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask175"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath176 || (_clipPath176 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip176"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface532",
    clipPath: "url(#clip176)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 507.521796 162.984375 L 508.015625 165.486328 L 506.983073 165.486328 Z M 507.521796 162.984375 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask176"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath177 || (_clipPath177 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip177"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface535",
    clipPath: "url(#clip177)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 380.517889 164.011963 C 383.031929 170.802979 386.713202 176.477051 391.516814 180.989502 L 407.005095 190.505859 L 405.478714 190.997314 C 399.01404 188.182617 393.537024 184.38501 389.002774 179.515137 C 384.468524 175.226074 381.640229 170.088135 380.517889 164.011963 Z M 380.517889 164.011963 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask177"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath178 || (_clipPath178 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip178"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface538",
    clipPath: "url(#clip178)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 622.494226 164.011963 L 622.988055 166.513916 L 622.000396 166.513916 Z M 622.494226 164.011963 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask178"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath179 || (_clipPath179 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip179"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface541",
    clipPath: "url(#clip179)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 38.518682 164.994873 L 50.011436 174.51123 L 47.497396 172.992188 C 43.187613 171.071045 40.179744 168.390381 38.518682 164.994873 Z M 38.518682 164.994873 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask179"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath180 || (_clipPath180 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip180"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface544",
    clipPath: "url(#clip180)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 561.483865 164.994873 L 561.977695 168.479736 L 560.990036 168.479736 Z M 561.483865 164.994873 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask180"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath181 || (_clipPath181 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip181"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface547",
    clipPath: "url(#clip181)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 31.515285 165.977783 L 26.981035 171.517822 L 16.520833 183.98291 L 21.01019 178.487549 Z M 31.515285 165.977783 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask181"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath182 || (_clipPath182 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip182"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface550",
    clipPath: "url(#clip182)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 506.489244 167.005371 L 506.983073 169.507324 L 505.995414 169.507324 Z M 506.489244 167.005371 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask182"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath183 || (_clipPath183 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip183"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface553",
    clipPath: "url(#clip183)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 621.506567 167.988281 L 622.000396 170.490234 L 620.518909 172.992188 L 619.980186 171.517822 Z M 621.506567 167.988281 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask183"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath184 || (_clipPath184 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip184"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface556",
    clipPath: "url(#clip184)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 188.508096 169.015869 L 189.001925 171.517822 L 188.014266 171.517822 Z M 188.508096 169.015869 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask184"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath185 || (_clipPath185 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip185"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface559",
    clipPath: "url(#clip185)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 135.488791 170.981689 L 135.98262 173.483643 L 134.994962 173.483643 Z M 135.488791 170.981689 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask185"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath186 || (_clipPath186 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip186"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface562",
    clipPath: "url(#clip186)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 178.49683 172.009277 L 178.990659 175.494141 L 178.003 175.494141 Z M 178.49683 172.009277 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask186"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath187 || (_clipPath187 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip187"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface565",
    clipPath: "url(#clip187)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 235.511662 172.009277 L 236.499321 174.019775 Z M 235.511662 172.009277 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask187"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath188 || (_clipPath188 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip188"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface568",
    clipPath: "url(#clip188)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 313.491791 172.009277 L 341.011549 197.520264 L 327.498585 211.99585 L 339.978997 198.503174 L 337.509851 195.018311 L 313.491791 172.992188 L 306.982224 178.487549 Z M 313.491791 172.009277 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask188"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath189 || (_clipPath189 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip189"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface571",
    clipPath: "url(#clip189)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 459.485677 172.009277 L 458.991848 173.483643 L 455.490149 177.996094 L 458.004189 174.51123 Z M 459.485677 172.009277 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask189"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath190 || (_clipPath190 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip190"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface574",
    clipPath: "url(#clip190)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 563.504076 172.992188 L 566.018116 177.504639 L 563.997905 176.521729 Z M 563.504076 172.992188 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask190"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath191 || (_clipPath191 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip191"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface577",
    clipPath: "url(#clip191)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 504.513927 174.019775 L 505.007756 175.494141 L 503.481375 177.996094 L 502.987545 176.521729 Z M 504.513927 174.019775 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask191"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath192 || (_clipPath192 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip192"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface580",
    clipPath: "url(#clip192)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 51.492923 175.002686 L 52.480582 177.013184 Z M 51.492923 175.002686 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask192"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath193 || (_clipPath193 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip193"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface583",
    clipPath: "url(#clip193)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 134.501132 175.002686 L 134.994962 176.521729 L 133.019644 177.504639 Z M 134.501132 175.002686 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask193"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath194 || (_clipPath194 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip194"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface586",
    clipPath: "url(#clip194)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 237.486979 175.002686 L 242.02123 180.498047 L 240.988678 180.498047 Z M 237.486979 175.002686 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask194"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath195 || (_clipPath195 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip195"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface589",
    clipPath: "url(#clip195)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 190.483413 175.985596 L 192.009794 179.515137 L 191.022135 179.515137 Z M 190.483413 175.985596 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask195"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath196 || (_clipPath196 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip196"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface592",
    clipPath: "url(#clip196)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 618.498698 175.985596 L 618.004869 177.504639 L 610.507643 185.993408 L 604.491904 188.986816 L 604.491904 188.003906 C 609.879133 186.082764 614.054235 182.910645 617.01721 178.487549 Z M 618.498698 175.985596 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask196"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath197 || (_clipPath197 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip197"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface595",
    clipPath: "url(#clip197)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 54.500793 177.013184 L 58.002491 179.515137 L 56.521003 178.979004 Z M 54.500793 177.013184 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask197"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath198 || (_clipPath198 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip198"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface598",
    clipPath: "url(#clip198)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 339.485168 177.013184 L 341.011549 180.498047 L 339.978997 180.498047 Z M 339.485168 177.013184 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask198"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath199 || (_clipPath199 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip199"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface601",
    clipPath: "url(#clip199)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 177.509171 177.996094 L 178.003 180.498047 L 177.015342 180.498047 Z M 177.509171 177.996094 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask199"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath200 || (_clipPath200 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip200"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface604",
    clipPath: "url(#clip200)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 132.480922 178.979004 L 126.510077 185.993408 L 124.489866 187.020996 L 125.522418 185.010498 Z M 132.480922 178.979004 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask200"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath201 || (_clipPath201 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip201"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface607",
    clipPath: "url(#clip201)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 305.500736 178.979004 L 302.492867 183 Z M 305.500736 178.979004 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask201"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath202 || (_clipPath202 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip202"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface610",
    clipPath: "url(#clip202)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 454.502491 178.979004 L 451.494622 183 L 447.499094 185.993408 L 450.506963 182.01709 Z M 454.502491 178.979004 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask202"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath203 || (_clipPath203 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip203"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface613",
    clipPath: "url(#clip203)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 566.511945 178.979004 L 570.507473 183.98291 L 574.009171 186.484863 L 571.495131 185.010498 L 567.993433 182.508545 Z M 566.511945 178.979004 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask203"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath204 || (_clipPath204 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip204"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface616",
    clipPath: "url(#clip204)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 518.52072 180.006592 L 519.014549 183.491455 L 517.981997 183.491455 Z M 518.52072 180.006592 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask204"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath205 || (_clipPath205 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip205"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface619",
    clipPath: "url(#clip205)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 61.504189 180.989502 L 68.013757 184.519043 L 66.487375 185.010498 C 63.434613 184.206299 61.773551 182.865967 61.504189 180.989502 Z M 61.504189 180.989502 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask205"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath206 || (_clipPath206 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip206"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface622",
    clipPath: "url(#clip206)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 243.502717 180.989502 C 247.18399 185.323242 251.987602 188.495361 258.00334 190.505859 L 256.521852 190.997314 C 250.236753 188.808105 245.882077 185.457275 243.502717 180.989502 Z M 243.502717 180.989502 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask206"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath207 || (_clipPath207 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip207"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface625",
    clipPath: "url(#clip207)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 501.506058 180.989502 L 501.999887 182.508545 L 499.485847 185.993408 L 499.979676 184.519043 Z M 501.506058 180.989502 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask207"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath208 || (_clipPath208 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip208"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface628",
    clipPath: "url(#clip208)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 300.51755 183 L 298.497339 185.993408 L 296.522022 187.020996 L 297.509681 185.010498 Z M 300.51755 183 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask208"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath209 || (_clipPath209 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip209"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface631",
    clipPath: "url(#clip209)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 15.488281 185.010498 L 11.492754 190.014404 Z M 15.488281 185.010498 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask209"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath210 || (_clipPath210 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip210"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface634",
    clipPath: "url(#clip210)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 445.478884 185.993408 L 444.491225 188.003906 L 437.487828 190.997314 L 437.487828 190.014404 Z M 445.478884 185.993408 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask210"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath211 || (_clipPath211 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip211"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface637",
    clipPath: "url(#clip211)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 741.507077 185.993408 L 745.996433 189.478271 L 744.514946 188.986816 Z M 741.507077 185.993408 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask211"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath212 || (_clipPath212 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip212"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface640",
    clipPath: "url(#clip212)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 121.481997 187.020996 L 123.008379 187.512451 L 119.50668 188.986816 L 119.50668 188.003906 Z M 121.481997 187.020996 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask212"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath213 || (_clipPath213 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip213"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface643",
    clipPath: "url(#clip213)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 294.501812 187.020996 L 293.514153 188.986816 L 288.486073 190.997314 L 288.486073 190.014404 Z M 294.501812 187.020996 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask213"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath214 || (_clipPath214 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip214"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface646",
    clipPath: "url(#clip214)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 77.4863 188.003906 L 80.00034 188.495361 L 77.4863 188.986816 Z M 77.4863 188.003906 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask214"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath215 || (_clipPath215 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip215"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface649",
    clipPath: "url(#clip215)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 344.513247 188.003906 L 346.982394 191.48877 L 345.007077 190.505859 Z M 344.513247 188.003906 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask215"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath216 || (_clipPath216 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip216"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface652",
    clipPath: "url(#clip216)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 81.481827 188.986816 L 83.995867 189.478271 L 81.481827 190.014404 Z M 81.481827 188.986816 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask216"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath217 || (_clipPath217 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip217"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface655",
    clipPath: "url(#clip217)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 174.501302 188.986816 L 174.995131 190.505859 L 170.505774 198.011719 L 170.999604 196.492676 Z M 174.501302 188.986816 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask217"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath218 || (_clipPath218 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip218"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface658",
    clipPath: "url(#clip218)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 196.499151 188.986816 L 199.013191 192.516357 L 196.99298 191.48877 Z M 196.499151 188.986816 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask218"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath219 || (_clipPath219 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip219"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface661",
    clipPath: "url(#clip219)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 497.51053 188.986816 L 497.016701 190.505859 C 492.123302 199.620117 485.613734 207.125977 477.487998 212.97876 L 468.509284 219.010254 L 469.496943 216.999756 C 478.251189 212.397949 485.389266 206.232422 491.000962 198.503174 Z M 497.51053 188.986816 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask219"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath220 || (_clipPath220 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip220"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface664",
    clipPath: "url(#clip220)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 86.509907 190.014404 L 90.999264 190.505859 L 86.509907 190.997314 Z M 86.509907 190.014404 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask220"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath221 || (_clipPath221 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip221"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface667",
    clipPath: "url(#clip221)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 111.515625 190.014404 L 113.984771 190.505859 L 111.515625 190.997314 Z M 111.515625 190.014404 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask221"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath222 || (_clipPath222 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip222"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface670",
    clipPath: "url(#clip222)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 582.494056 190.014404 L 585.995754 190.505859 L 582.494056 190.997314 Z M 582.494056 190.014404 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask222"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath223 || (_clipPath223 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip223"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface673",
    clipPath: "url(#clip223)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 596.500849 190.014404 L 600.002548 190.505859 L 596.500849 190.997314 Z M 596.500849 190.014404 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask223"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath224 || (_clipPath224 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip224"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface676",
    clipPath: "url(#clip224)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 762.517267 190.014404 L 766.018965 190.505859 L 762.517267 190.997314 Z M 762.517267 190.014404 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask224"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath225 || (_clipPath225 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip225"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface679",
    clipPath: "url(#clip225)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 10.505095 190.997314 L 8.978714 193.499268 L 11.986583 197.520264 L 7.991055 194.482178 Z M 10.505095 190.997314 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask225"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath226 || (_clipPath226 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip226"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface682",
    clipPath: "url(#clip226)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 95.488621 190.997314 L 106.981375 191.48877 L 95.488621 191.980225 Z M 95.488621 190.997314 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask226"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath227 || (_clipPath227 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip227"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface685",
    clipPath: "url(#clip227)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 284.490546 190.997314 L 287.004586 191.48877 L 284.490546 191.980225 Z M 284.490546 190.997314 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask227"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath228 || (_clipPath228 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip228"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface688",
    clipPath: "url(#clip228)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 408.486583 190.997314 L 411.000623 191.48877 L 408.486583 191.980225 Z M 408.486583 190.997314 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask228"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath229 || (_clipPath229 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip229"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface691",
    clipPath: "url(#clip229)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 433.492301 190.997314 L 436.006341 191.48877 L 433.492301 191.980225 Z M 433.492301 190.997314 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask229"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath230 || (_clipPath230 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip230"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface694",
    clipPath: "url(#clip230)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 751.518342 190.997314 L 759.015568 191.48877 L 751.518342 191.980225 Z M 751.518342 190.997314 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask230"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath231 || (_clipPath231 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip231"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface697",
    clipPath: "url(#clip231)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 263.480356 191.980225 L 265.994395 192.516357 L 263.480356 193.007812 Z M 263.480356 191.980225 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask231"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath232 || (_clipPath232 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip232"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface700",
    clipPath: "url(#clip232)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 279.50736 191.980225 L 283.009058 192.516357 L 279.50736 193.007812 Z M 279.50736 191.980225 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask232"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath233 || (_clipPath233 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip233"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface703",
    clipPath: "url(#clip233)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 412.482111 191.980225 L 414.99615 192.516357 L 412.482111 193.007812 Z M 412.482111 191.980225 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask233"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath234 || (_clipPath234 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip234"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface706",
    clipPath: "url(#clip234)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 428.509115 191.980225 L 432.010813 192.516357 L 428.509115 193.007812 Z M 428.509115 191.980225 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask234"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath235 || (_clipPath235 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip235"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface709",
    clipPath: "url(#clip235)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 347.521116 193.007812 L 352.998132 199.486084 L 349.002604 196.492676 Z M 347.521116 193.007812 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask235"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath236 || (_clipPath236 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip236"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface712",
    clipPath: "url(#clip236)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 696.478827 193.007812 L 697.01755 195.509766 L 695.984998 195.509766 Z M 696.478827 193.007812 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask236"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath237 || (_clipPath237 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip237"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface715",
    clipPath: "url(#clip237)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 199.50702 193.990723 L 213.513813 209.985352 L 221.998698 216.508301 L 219.484658 214.989258 L 204.984035 202.479492 Z M 199.50702 193.990723 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask237"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath238 || (_clipPath238 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip238"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface718",
    clipPath: "url(#clip238)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 522.516248 196.001221 L 527.005605 204.48999 L 524.985394 203.50708 Z M 522.516248 196.001221 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask238"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath239 || (_clipPath239 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip239"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface721",
    clipPath: "url(#clip239)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 13.512964 198.011719 L 25.005718 207.483398 L 22.491678 206.009033 C 18.181895 204.087891 15.174026 201.407227 13.512964 198.011719 Z M 13.512964 198.011719 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask239"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath240 || (_clipPath240 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip240"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface724",
    clipPath: "url(#clip240)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 697.511379 198.011719 L 699.980525 205.517578 L 698.992867 205.517578 Z M 697.511379 198.011719 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask240"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath241 || (_clipPath241 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip241"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface727",
    clipPath: "url(#clip241)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 169.518116 198.994629 L 168.485564 201.005127 Z M 169.518116 198.994629 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask241"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath242 || (_clipPath242 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip242"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface730",
    clipPath: "url(#clip242)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 353.491961 201.005127 L 362.515568 211.012939 Z M 353.491961 201.005127 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask242"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath243 || (_clipPath243 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip243"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface733",
    clipPath: "url(#clip243)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 167.497905 201.988037 L 165.477695 204.981445 Z M 167.497905 201.988037 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask243"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath244 || (_clipPath244 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip244"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface736",
    clipPath: "url(#clip244)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 164.490036 206.009033 L 158.519192 212.97876 Z M 164.490036 206.009033 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask244"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath245 || (_clipPath245 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip245"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface739",
    clipPath: "url(#clip245)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 527.499434 206.009033 L 531.988791 211.504395 L 527.993263 208.510986 Z M 527.499434 206.009033 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask245"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath246 || (_clipPath246 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip246"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface742",
    clipPath: "url(#clip246)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 26.487206 208.019531 L 27.519758 209.985352 Z M 26.487206 208.019531 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask246"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath247 || (_clipPath247 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip247"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface745",
    clipPath: "url(#clip247)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 29.495075 209.985352 L 32.996773 212.487305 L 31.515285 211.99585 Z M 29.495075 209.985352 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask247"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath248 || (_clipPath248 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip248"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface748",
    clipPath: "url(#clip248)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 364.490885 211.012939 L 378.00385 220.484619 L 376.522362 219.993164 C 370.551517 218.072021 366.55599 215.078613 364.490885 211.012939 Z M 364.490885 211.012939 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask248"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath249 || (_clipPath249 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip249"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface751",
    clipPath: "url(#clip249)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 702.494565 211.012939 L 703.482224 212.97876 Z M 702.494565 211.012939 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask249"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath250 || (_clipPath250 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip250"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface754",
    clipPath: "url(#clip250)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 325.478374 211.99585 L 322.515399 216.016846 L 319.507529 217.982666 L 321.482846 214.989258 Z M 325.478374 211.99585 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask250"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath251 || (_clipPath251 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip251"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface757",
    clipPath: "url(#clip251)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 34.478261 212.97876 L 47.003567 219.501709 L 45.522079 219.993164 L 35.510813 214.989258 Z M 34.478261 212.97876 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask251"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath252 || (_clipPath252 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip252"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface760",
    clipPath: "url(#clip252)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 156.498981 212.97876 L 153.491112 216.999756 L 148.507926 219.993164 L 149.495584 217.982666 Z M 156.498981 212.97876 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask252"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath253 || (_clipPath253 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip253"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface763",
    clipPath: "url(#clip253)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 532.48262 212.97876 L 544.020267 222.495117 L 542.493886 222.003662 C 537.780061 219.859131 534.413043 216.865723 532.48262 212.97876 Z M 532.48262 212.97876 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask253"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath254 || (_clipPath254 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip254"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface766",
    clipPath: "url(#clip254)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 704.514776 214.006348 C 708.779665 219.725098 714.615829 223.880127 721.978374 226.516113 L 720.496886 227.007568 C 713.089447 224.058838 707.747113 219.725098 704.514776 214.006348 Z M 704.514776 214.006348 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask254"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath255 || (_clipPath255 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip255"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface769",
    clipPath: "url(#clip255)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 223.480186 216.999756 L 226.981884 219.501709 L 225.500396 219.010254 Z M 223.480186 216.999756 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask255"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath256 || (_clipPath256 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip256"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface772",
    clipPath: "url(#clip256)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 614.50317 216.999756 L 611.495301 221.020752 Z M 614.50317 216.999756 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask256"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath257 || (_clipPath257 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip257"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface775",
    clipPath: "url(#clip257)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 317.487319 217.982666 L 316.49966 219.993164 L 314.47945 221.020752 L 315.512002 219.010254 Z M 317.487319 217.982666 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask257"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath258 || (_clipPath258 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip258"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface778",
    clipPath: "url(#clip258)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 228.508265 219.993164 L 235.017833 223.478027 L 233.491452 224.01416 C 230.438689 223.209961 228.777627 221.869629 228.508265 219.993164 Z M 228.508265 219.993164 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask258"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath259 || (_clipPath259 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip259"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface781",
    clipPath: "url(#clip259)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 464.513757 219.993164 L 463.481205 222.003662 L 460.518229 222.986572 L 460.518229 222.003662 Z M 464.513757 219.993164 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask259"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath260 || (_clipPath260 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip260"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface784",
    clipPath: "url(#clip260)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 312.504133 221.020752 L 311.516474 222.986572 L 304.513077 225.97998 L 304.513077 224.99707 Z M 312.504133 221.020752 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask260"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath261 || (_clipPath261 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip261"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface787",
    clipPath: "url(#clip261)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 609.519984 221.020752 L 607.499774 224.01416 L 594.480639 229.018066 L 594.480639 227.990479 C 601.0351 227.186279 606.018286 224.863037 609.519984 221.020752 Z M 609.519984 221.020752 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask261"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath262 || (_clipPath262 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip262"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface790",
    clipPath: "url(#clip262)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 779.487036 221.020752 L 781.013417 221.512207 L 771.495981 225.97998 L 771.495981 224.99707 Z M 779.487036 221.020752 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask262"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath263 || (_clipPath263 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip263"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface793",
    clipPath: "url(#clip263)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 53.513134 222.003662 L 61.01036 224.505615 L 58.49632 224.99707 L 53.513134 222.986572 Z M 53.513134 222.003662 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask263"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath264 || (_clipPath264 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip264"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface796",
    clipPath: "url(#clip264)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 383.480865 222.986572 L 386.982563 224.505615 L 385.501076 224.99707 Z M 383.480865 222.986572 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask264"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath265 || (_clipPath265 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip265"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface799",
    clipPath: "url(#clip265)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 545.501755 222.986572 L 549.991112 225.488525 L 548.509624 225.97998 Z M 545.501755 222.986572 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask265"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath266 || (_clipPath266 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip266"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface802",
    clipPath: "url(#clip266)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 136.521343 224.01416 L 138.002831 224.505615 L 134.501132 225.97998 L 134.501132 224.99707 Z M 136.521343 224.01416 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask266"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath267 || (_clipPath267 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip267"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface805",
    clipPath: "url(#clip267)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 455.490149 224.01416 L 457.016531 224.505615 L 453.514832 225.97998 L 453.514832 224.99707 Z M 455.490149 224.01416 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask267"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath268 || (_clipPath268 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip268"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface808",
    clipPath: "url(#clip268)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 388.508945 224.99707 L 396.006171 227.499023 L 393.492131 227.990479 L 388.508945 225.97998 Z M 388.508945 224.99707 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask268"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath269 || (_clipPath269 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip269"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface811",
    clipPath: "url(#clip269)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 65.499717 225.97998 L 68.013757 226.516113 L 65.499717 227.007568 Z M 65.499717 225.97998 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask269"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath270 || (_clipPath270 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip270"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface814",
    clipPath: "url(#clip270)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 130.505605 225.97998 L 133.019644 226.516113 L 130.505605 227.007568 Z M 130.505605 225.97998 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask270"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath271 || (_clipPath271 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip271"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface817",
    clipPath: "url(#clip271)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 551.517493 225.97998 L 555.019192 227.499023 L 553.49281 227.990479 Z M 551.517493 225.97998 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask271"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath272 || (_clipPath272 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip272"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface820",
    clipPath: "url(#clip272)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 70.482903 227.007568 L 72.996943 227.499023 L 70.482903 227.990479 Z M 70.482903 227.007568 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask272"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath273 || (_clipPath273 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip273"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface823",
    clipPath: "url(#clip273)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 126.510077 227.007568 L 128.979223 227.499023 L 126.510077 227.990479 Z M 126.510077 227.007568 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask273"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath274 || (_clipPath274 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip274"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface826",
    clipPath: "url(#clip274)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 74.478431 227.990479 L 77.980129 228.481934 L 74.478431 229.018066 Z M 74.478431 227.990479 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask274"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath275 || (_clipPath275 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip275"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface829",
    clipPath: "url(#clip275)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 122.514549 227.990479 L 124.983696 228.481934 L 122.514549 229.018066 Z M 122.514549 227.990479 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask275"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath276 || (_clipPath276 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip276"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface832",
    clipPath: "url(#clip276)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 247.498245 227.990479 L 250.012285 228.481934 L 247.498245 229.018066 Z M 247.498245 227.990479 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask276"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath277 || (_clipPath277 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip277"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface835",
    clipPath: "url(#clip277)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 294.501812 227.990479 L 297.015851 228.481934 L 294.501812 229.018066 Z M 294.501812 227.990479 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask277"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath278 || (_clipPath278 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip278"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface838",
    clipPath: "url(#clip278)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 397.487659 227.990479 L 400.001698 228.481934 L 397.487659 229.018066 Z M 397.487659 227.990479 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask278"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath279 || (_clipPath279 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip279"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface841",
    clipPath: "url(#clip279)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 443.503567 227.990479 L 446.017606 228.481934 L 443.503567 229.018066 Z M 443.503567 227.990479 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask279"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath280 || (_clipPath280 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip280"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface844",
    clipPath: "url(#clip280)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 556.500679 227.990479 L 559.014719 228.481934 L 556.500679 229.018066 Z M 556.500679 227.990479 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask280"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath281 || (_clipPath281 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip281"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface847",
    clipPath: "url(#clip281)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 761.484715 227.990479 L 763.998755 228.481934 L 761.484715 229.018066 Z M 761.484715 227.990479 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask281"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath282 || (_clipPath282 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip282"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface850",
    clipPath: "url(#clip282)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 80.494169 229.018066 L 84.983526 229.509521 L 80.494169 230.000977 Z M 80.494169 229.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask282"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath283 || (_clipPath283 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip283"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface853",
    clipPath: "url(#clip283)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 115.511153 229.018066 L 120.00051 229.509521 L 115.511153 230.000977 Z M 115.511153 229.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask283"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath284 || (_clipPath284 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip284"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface856",
    clipPath: "url(#clip284)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 251.493773 229.018066 L 254.007812 229.509521 L 251.493773 230.000977 Z M 251.493773 229.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask284"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath285 || (_clipPath285 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip285"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface859",
    clipPath: "url(#clip285)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 289.518625 229.018066 L 291.987772 229.509521 L 289.518625 230.000977 Z M 289.518625 229.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask285"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath286 || (_clipPath286 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip286"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface862",
    clipPath: "url(#clip286)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 401.483186 229.018066 L 403.997226 229.509521 L 401.483186 230.000977 Z M 401.483186 229.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask286"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath287 || (_clipPath287 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip287"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface865",
    clipPath: "url(#clip287)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 438.52038 229.018066 L 440.989527 229.509521 L 438.52038 230.000977 Z M 438.52038 229.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask287"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath288 || (_clipPath288 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip288"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface868",
    clipPath: "url(#clip288)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 560.496207 229.018066 L 563.010247 229.509521 L 560.496207 230.000977 Z M 560.496207 229.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask288"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath289 || (_clipPath289 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip289"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface871",
    clipPath: "url(#clip289)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 590.485111 229.018066 L 592.999151 229.509521 L 590.485111 230.000977 Z M 590.485111 229.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask289"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath290 || (_clipPath290 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip290"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface874",
    clipPath: "url(#clip290)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 731.495811 229.018066 L 734.997509 229.509521 L 731.495811 230.000977 Z M 731.495811 229.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask290"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath291 || (_clipPath291 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip291"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface877",
    clipPath: "url(#clip291)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 755.51387 229.018066 L 759.015568 229.509521 L 755.51387 230.000977 Z M 755.51387 229.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask291"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath292 || (_clipPath292 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip292"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface880",
    clipPath: "url(#clip292)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 90.505435 230.000977 L 111.021796 230.492432 L 90.505435 230.983887 Z M 90.505435 230.000977 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask292"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath293 || (_clipPath293 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip293"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface883",
    clipPath: "url(#clip293)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 257.509511 230.000977 L 261.011209 230.492432 L 257.509511 230.983887 Z M 257.509511 230.000977 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask293"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath294 || (_clipPath294 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip294"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface886",
    clipPath: "url(#clip294)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 282.515229 230.000977 L 287.004586 230.492432 L 282.515229 230.983887 Z M 282.515229 230.000977 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask294"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath295 || (_clipPath295 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip295"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface889",
    clipPath: "url(#clip295)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 407.498924 230.000977 L 411.000623 230.492432 L 407.498924 230.983887 Z M 407.498924 230.000977 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask295"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath296 || (_clipPath296 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip296"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface892",
    clipPath: "url(#clip296)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 431.516984 230.000977 L 436.006341 230.492432 L 431.516984 230.983887 Z M 431.516984 230.000977 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask296"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath297 || (_clipPath297 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip297"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface895",
    clipPath: "url(#clip297)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 566.511945 230.000977 L 571.001302 230.492432 L 566.511945 230.983887 Z M 566.511945 230.000977 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask297"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath298 || (_clipPath298 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip298"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface898",
    clipPath: "url(#clip298)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 582.494056 230.000977 L 588.015965 230.492432 L 582.494056 230.983887 Z M 582.494056 230.000977 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask298"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.486275,
      stroke: "none"
    }
  }))), _clipPath299 || (_clipPath299 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip299"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface901",
    clipPath: "url(#clip299)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 740.519418 230.000977 L 749.004303 230.492432 L 740.519418 230.983887 Z M 740.519418 230.000977 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask299"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath300 || (_clipPath300 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip300"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface904",
    clipPath: "url(#clip300)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(78.431373%,3.137255%,8.235294%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(78.431373%,3.137255%,8.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 101.504359 263.017822 L 688.487772 263.017822 L 701.506907 266.994141 L 710.97945 275.48291 L 712.99966 279.503906 L 712.99966 520.495605 L 705.502434 530.011963 L 698.499038 533.988281 L 685.479903 536.981689 L 103.479676 536.981689 C 102.626698 535.552002 100.651381 535.19458 97.508832 535.998779 L 85.522249 530.994873 L 77.980129 523.489014 L 76.992471 521.478516 L 76.992471 278.520996 L 83.502038 269.987549 L 90.505435 266.01123 Z M 571.988961 303.004395 L 550.97877 308.008301 L 533.021343 318.999023 L 520.002208 336.02124 L 516.994339 344.018555 L 516.00668 355.992188 L 515.019022 357.019775 L 516.00668 370.020996 L 517.981997 378.018311 L 523.010077 387.981445 L 527.993263 394.012939 L 538.004529 400.982666 L 549.991112 407.01416 C 561.977695 411.660645 575.670233 415.324219 590.97894 418.004883 L 610.013813 426.002197 L 614.997 431.989014 L 617.01721 439.003418 C 617.01721 443.649902 615.984658 447.670898 614.009341 451.021729 C 611.315727 454.327881 607.679348 457.008545 603.010417 459.019043 L 592.999151 460.984863 L 582.000226 460.984863 L 564.985564 457.991455 L 549.991112 451.021729 L 531.988791 436.99292 L 530.013474 436.99292 L 508.015625 463.978271 C 516.680084 472.645752 527.31986 479.660156 539.979846 485.021484 L 553.986639 489.980713 L 574.009171 494.001709 L 600.002548 494.001709 C 600.675951 492.661377 602.651268 492.348633 606.018286 493.018799 L 622.000396 488.014893 L 635.019531 480.017578 C 640.990376 475.326416 645.659307 469.3396 648.981431 462.012451 L 653.021852 449.01123 L 653.021852 441.013916 L 654.009511 439.986328 L 653.021852 426.985107 L 651.001642 420.015381 L 646.018456 410.007568 L 640.990376 402.993164 L 621.012738 389.991943 L 592.999151 381.011719 L 589.003623 381.011719 L 571.988961 376.007812 L 556.00685 368.010498 L 552.998981 363.006592 L 552.011322 358.002686 L 553.986639 347.994873 C 557.353657 342.008057 563.010247 338.344482 571.001302 337.00415 L 589.003623 337.00415 L 597.982337 339.014648 C 609.34041 342.990967 619.665931 348.665039 629.003793 355.992188 L 646.018456 332.983154 L 647.993773 327.979248 C 637.353997 318.016113 624.020607 310.688965 607.993603 305.997803 L 597.982337 303.987305 L 590.97894 303.987305 L 589.991282 303.004395 Z M 135.98262 305.997803 L 135.98262 491.008301 L 138.002831 491.991211 L 214.007643 491.991211 L 214.995301 491.008301 L 229.002095 489.980713 C 247.677819 486.004395 263.345675 478.319824 276.005661 467.016357 C 285.343524 458.348877 292.661175 447.983643 298.00351 436.01001 L 304.019248 415.994385 C 302.672441 411.3479 302.986696 408.667236 305.006907 407.99707 L 305.006907 389.991943 L 301.011379 370.020996 C 297.015851 356.662354 290.685858 345.671631 282.021399 337.00415 C 269.316519 323.02002 252.661005 313.324951 232.009964 308.008301 L 221.011039 305.997803 Z M 327.992414 305.997803 L 327.992414 491.008301 L 330.012625 491.991211 L 363.997056 491.991211 L 364.984715 491.008301 L 366.017267 368.993408 L 458.991848 491.008301 L 461.999717 491.991211 L 490.013304 491.991211 L 491.000962 491.008301 L 491.000962 305.997803 L 454.008662 305.997803 L 454.008662 425.019287 L 363.997056 308.991211 L 362.021739 305.997803 Z M 327.992414 305.997803 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask300"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48,
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 0.992157,
      stroke: "none"
    }
  }))), _clipPath301 || (_clipPath301 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip301"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 69,
    height: 48
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface907",
    clipPath: "url(#clip301)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(78.431373%,3.137255%,8.235294%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(78.431373%,3.137255%,8.235294%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 173.019814 339.997559 L 216.521683 339.997559 L 221.504869 340.980469 C 234.344429 344.152588 244.535269 349.960693 251.987602 358.494141 C 257.329937 364.480957 261.325464 371.852783 264.019078 380.520264 L 265.994395 390.483398 L 265.994395 406.478027 L 262.986526 420.506836 L 257.015682 432.480469 L 244.490376 446.017822 C 237.756341 451.245117 229.45103 454.953369 219.484658 457.008545 L 211.493603 457.008545 L 210.505944 457.991455 L 173.019814 457.991455 Z M 173.019814 339.997559 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface7",
    mask: "url(#mask0)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface10",
    mask: "url(#mask1)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface13",
    mask: "url(#mask2)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface16",
    mask: "url(#mask3)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface19",
    mask: "url(#mask4)"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface22",
    mask: "url(#mask5)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface25",
    mask: "url(#mask6)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface28",
    mask: "url(#mask7)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface31",
    mask: "url(#mask8)"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface34",
    mask: "url(#mask9)"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface37",
    mask: "url(#mask10)"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface40",
    mask: "url(#mask11)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface43",
    mask: "url(#mask12)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface46",
    mask: "url(#mask13)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface49",
    mask: "url(#mask14)"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface52",
    mask: "url(#mask15)"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface55",
    mask: "url(#mask16)"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface58",
    mask: "url(#mask17)"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface61",
    mask: "url(#mask18)"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface64",
    mask: "url(#mask19)"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface67",
    mask: "url(#mask20)"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface70",
    mask: "url(#mask21)"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface73",
    mask: "url(#mask22)"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface76",
    mask: "url(#mask23)"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface79",
    mask: "url(#mask24)"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface82",
    mask: "url(#mask25)"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface85",
    mask: "url(#mask26)"
  })), _use28 || (_use28 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface88",
    mask: "url(#mask27)"
  })), _use29 || (_use29 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface91",
    mask: "url(#mask28)"
  })), _use30 || (_use30 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface94",
    mask: "url(#mask29)"
  })), _use31 || (_use31 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface97",
    mask: "url(#mask30)"
  })), _use32 || (_use32 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface100",
    mask: "url(#mask31)"
  })), _use33 || (_use33 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface103",
    mask: "url(#mask32)"
  })), _use34 || (_use34 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface106",
    mask: "url(#mask33)"
  })), _use35 || (_use35 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface109",
    mask: "url(#mask34)"
  })), _use36 || (_use36 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface112",
    mask: "url(#mask35)"
  })), _use37 || (_use37 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface115",
    mask: "url(#mask36)"
  })), _use38 || (_use38 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface118",
    mask: "url(#mask37)"
  })), _use39 || (_use39 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface121",
    mask: "url(#mask38)"
  })), _use40 || (_use40 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface124",
    mask: "url(#mask39)"
  })), _use41 || (_use41 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface127",
    mask: "url(#mask40)"
  })), _use42 || (_use42 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface130",
    mask: "url(#mask41)"
  })), _use43 || (_use43 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface133",
    mask: "url(#mask42)"
  })), _use44 || (_use44 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface136",
    mask: "url(#mask43)"
  })), _use45 || (_use45 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface139",
    mask: "url(#mask44)"
  })), _use46 || (_use46 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface142",
    mask: "url(#mask45)"
  })), _use47 || (_use47 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface145",
    mask: "url(#mask46)"
  })), _use48 || (_use48 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface148",
    mask: "url(#mask47)"
  })), _use49 || (_use49 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface151",
    mask: "url(#mask48)"
  })), _use50 || (_use50 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface154",
    mask: "url(#mask49)"
  })), _use51 || (_use51 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface157",
    mask: "url(#mask50)"
  })), _use52 || (_use52 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface160",
    mask: "url(#mask51)"
  })), _use53 || (_use53 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface163",
    mask: "url(#mask52)"
  })), _use54 || (_use54 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface166",
    mask: "url(#mask53)"
  })), _use55 || (_use55 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface169",
    mask: "url(#mask54)"
  })), _use56 || (_use56 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface172",
    mask: "url(#mask55)"
  })), _use57 || (_use57 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface175",
    mask: "url(#mask56)"
  })), _use58 || (_use58 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface178",
    mask: "url(#mask57)"
  })), _use59 || (_use59 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface181",
    mask: "url(#mask58)"
  })), _use60 || (_use60 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface184",
    mask: "url(#mask59)"
  })), _use61 || (_use61 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface187",
    mask: "url(#mask60)"
  })), _use62 || (_use62 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface190",
    mask: "url(#mask61)"
  })), _use63 || (_use63 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface193",
    mask: "url(#mask62)"
  })), _use64 || (_use64 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface196",
    mask: "url(#mask63)"
  })), _use65 || (_use65 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface199",
    mask: "url(#mask64)"
  })), _use66 || (_use66 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface202",
    mask: "url(#mask65)"
  })), _use67 || (_use67 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface205",
    mask: "url(#mask66)"
  })), _use68 || (_use68 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface208",
    mask: "url(#mask67)"
  })), _use69 || (_use69 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface211",
    mask: "url(#mask68)"
  })), _use70 || (_use70 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface214",
    mask: "url(#mask69)"
  })), _use71 || (_use71 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface217",
    mask: "url(#mask70)"
  })), _use72 || (_use72 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface220",
    mask: "url(#mask71)"
  })), _use73 || (_use73 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface223",
    mask: "url(#mask72)"
  })), _use74 || (_use74 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface226",
    mask: "url(#mask73)"
  })), _use75 || (_use75 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface229",
    mask: "url(#mask74)"
  })), _use76 || (_use76 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface232",
    mask: "url(#mask75)"
  })), _use77 || (_use77 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface235",
    mask: "url(#mask76)"
  })), _use78 || (_use78 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface238",
    mask: "url(#mask77)"
  })), _use79 || (_use79 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface241",
    mask: "url(#mask78)"
  })), _use80 || (_use80 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface244",
    mask: "url(#mask79)"
  })), _use81 || (_use81 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface247",
    mask: "url(#mask80)"
  })), _use82 || (_use82 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface250",
    mask: "url(#mask81)"
  })), _use83 || (_use83 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface253",
    mask: "url(#mask82)"
  })), _use84 || (_use84 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface256",
    mask: "url(#mask83)"
  })), _use85 || (_use85 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface259",
    mask: "url(#mask84)"
  })), _use86 || (_use86 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface262",
    mask: "url(#mask85)"
  })), _use87 || (_use87 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface265",
    mask: "url(#mask86)"
  })), _use88 || (_use88 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface268",
    mask: "url(#mask87)"
  })), _use89 || (_use89 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface271",
    mask: "url(#mask88)"
  })), _use90 || (_use90 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface274",
    mask: "url(#mask89)"
  })), _use91 || (_use91 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface277",
    mask: "url(#mask90)"
  })), _use92 || (_use92 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface280",
    mask: "url(#mask91)"
  })), _use93 || (_use93 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface283",
    mask: "url(#mask92)"
  })), _use94 || (_use94 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface286",
    mask: "url(#mask93)"
  })), _use95 || (_use95 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface289",
    mask: "url(#mask94)"
  })), _use96 || (_use96 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface292",
    mask: "url(#mask95)"
  })), _use97 || (_use97 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface295",
    mask: "url(#mask96)"
  })), _use98 || (_use98 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface298",
    mask: "url(#mask97)"
  })), _use99 || (_use99 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface301",
    mask: "url(#mask98)"
  })), _use100 || (_use100 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface304",
    mask: "url(#mask99)"
  })), _use101 || (_use101 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface307",
    mask: "url(#mask100)"
  })), _use102 || (_use102 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface310",
    mask: "url(#mask101)"
  })), _use103 || (_use103 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface313",
    mask: "url(#mask102)"
  })), _use104 || (_use104 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface316",
    mask: "url(#mask103)"
  })), _use105 || (_use105 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface319",
    mask: "url(#mask104)"
  })), _use106 || (_use106 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface322",
    mask: "url(#mask105)"
  })), _use107 || (_use107 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface325",
    mask: "url(#mask106)"
  })), _use108 || (_use108 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface328",
    mask: "url(#mask107)"
  })), _use109 || (_use109 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface331",
    mask: "url(#mask108)"
  })), _use110 || (_use110 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface334",
    mask: "url(#mask109)"
  })), _use111 || (_use111 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface337",
    mask: "url(#mask110)"
  })), _use112 || (_use112 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface340",
    mask: "url(#mask111)"
  })), _use113 || (_use113 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface343",
    mask: "url(#mask112)"
  })), _use114 || (_use114 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface346",
    mask: "url(#mask113)"
  })), _use115 || (_use115 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface349",
    mask: "url(#mask114)"
  })), _use116 || (_use116 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface352",
    mask: "url(#mask115)"
  })), _use117 || (_use117 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface355",
    mask: "url(#mask116)"
  })), _use118 || (_use118 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface358",
    mask: "url(#mask117)"
  })), _use119 || (_use119 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface361",
    mask: "url(#mask118)"
  })), _use120 || (_use120 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface364",
    mask: "url(#mask119)"
  })), _use121 || (_use121 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface367",
    mask: "url(#mask120)"
  })), _use122 || (_use122 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface370",
    mask: "url(#mask121)"
  })), _use123 || (_use123 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface373",
    mask: "url(#mask122)"
  })), _use124 || (_use124 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface376",
    mask: "url(#mask123)"
  })), _use125 || (_use125 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface379",
    mask: "url(#mask124)"
  })), _use126 || (_use126 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface382",
    mask: "url(#mask125)"
  })), _use127 || (_use127 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface385",
    mask: "url(#mask126)"
  })), _use128 || (_use128 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface388",
    mask: "url(#mask127)"
  })), _use129 || (_use129 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface391",
    mask: "url(#mask128)"
  })), _use130 || (_use130 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface394",
    mask: "url(#mask129)"
  })), _use131 || (_use131 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface397",
    mask: "url(#mask130)"
  })), _use132 || (_use132 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface400",
    mask: "url(#mask131)"
  })), _use133 || (_use133 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface403",
    mask: "url(#mask132)"
  })), _use134 || (_use134 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface406",
    mask: "url(#mask133)"
  })), _use135 || (_use135 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface409",
    mask: "url(#mask134)"
  })), _use136 || (_use136 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface412",
    mask: "url(#mask135)"
  })), _use137 || (_use137 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface415",
    mask: "url(#mask136)"
  })), _use138 || (_use138 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface418",
    mask: "url(#mask137)"
  })), _use139 || (_use139 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface421",
    mask: "url(#mask138)"
  })), _use140 || (_use140 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface424",
    mask: "url(#mask139)"
  })), _use141 || (_use141 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface427",
    mask: "url(#mask140)"
  })), _use142 || (_use142 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface430",
    mask: "url(#mask141)"
  })), _use143 || (_use143 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface433",
    mask: "url(#mask142)"
  })), _use144 || (_use144 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface436",
    mask: "url(#mask143)"
  })), _use145 || (_use145 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface439",
    mask: "url(#mask144)"
  })), _use146 || (_use146 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface442",
    mask: "url(#mask145)"
  })), _use147 || (_use147 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface445",
    mask: "url(#mask146)"
  })), _use148 || (_use148 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface448",
    mask: "url(#mask147)"
  })), _use149 || (_use149 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface451",
    mask: "url(#mask148)"
  })), _use150 || (_use150 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface454",
    mask: "url(#mask149)"
  })), _use151 || (_use151 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface457",
    mask: "url(#mask150)"
  })), _use152 || (_use152 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface460",
    mask: "url(#mask151)"
  })), _use153 || (_use153 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface463",
    mask: "url(#mask152)"
  })), _use154 || (_use154 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface466",
    mask: "url(#mask153)"
  })), _use155 || (_use155 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface469",
    mask: "url(#mask154)"
  })), _use156 || (_use156 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface472",
    mask: "url(#mask155)"
  })), _use157 || (_use157 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface475",
    mask: "url(#mask156)"
  })), _use158 || (_use158 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface478",
    mask: "url(#mask157)"
  })), _use159 || (_use159 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface481",
    mask: "url(#mask158)"
  })), _use160 || (_use160 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface484",
    mask: "url(#mask159)"
  })), _use161 || (_use161 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface487",
    mask: "url(#mask160)"
  })), _use162 || (_use162 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface490",
    mask: "url(#mask161)"
  })), _use163 || (_use163 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface493",
    mask: "url(#mask162)"
  })), _use164 || (_use164 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface496",
    mask: "url(#mask163)"
  })), _use165 || (_use165 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface499",
    mask: "url(#mask164)"
  })), _use166 || (_use166 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface502",
    mask: "url(#mask165)"
  })), _use167 || (_use167 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface505",
    mask: "url(#mask166)"
  })), _use168 || (_use168 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface508",
    mask: "url(#mask167)"
  })), _use169 || (_use169 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface511",
    mask: "url(#mask168)"
  })), _use170 || (_use170 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface514",
    mask: "url(#mask169)"
  })), _use171 || (_use171 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface517",
    mask: "url(#mask170)"
  })), _use172 || (_use172 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface520",
    mask: "url(#mask171)"
  })), _use173 || (_use173 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface523",
    mask: "url(#mask172)"
  })), _use174 || (_use174 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface526",
    mask: "url(#mask173)"
  })), _use175 || (_use175 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface529",
    mask: "url(#mask174)"
  })), _use176 || (_use176 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface532",
    mask: "url(#mask175)"
  })), _use177 || (_use177 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface535",
    mask: "url(#mask176)"
  })), _use178 || (_use178 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface538",
    mask: "url(#mask177)"
  })), _use179 || (_use179 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface541",
    mask: "url(#mask178)"
  })), _use180 || (_use180 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface544",
    mask: "url(#mask179)"
  })), _use181 || (_use181 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface547",
    mask: "url(#mask180)"
  })), _use182 || (_use182 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface550",
    mask: "url(#mask181)"
  })), _use183 || (_use183 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface553",
    mask: "url(#mask182)"
  })), _use184 || (_use184 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface556",
    mask: "url(#mask183)"
  })), _use185 || (_use185 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface559",
    mask: "url(#mask184)"
  })), _use186 || (_use186 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface562",
    mask: "url(#mask185)"
  })), _use187 || (_use187 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface565",
    mask: "url(#mask186)"
  })), _use188 || (_use188 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface568",
    mask: "url(#mask187)"
  })), _use189 || (_use189 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface571",
    mask: "url(#mask188)"
  })), _use190 || (_use190 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface574",
    mask: "url(#mask189)"
  })), _use191 || (_use191 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface577",
    mask: "url(#mask190)"
  })), _use192 || (_use192 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface580",
    mask: "url(#mask191)"
  })), _use193 || (_use193 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface583",
    mask: "url(#mask192)"
  })), _use194 || (_use194 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface586",
    mask: "url(#mask193)"
  })), _use195 || (_use195 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface589",
    mask: "url(#mask194)"
  })), _use196 || (_use196 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface592",
    mask: "url(#mask195)"
  })), _use197 || (_use197 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface595",
    mask: "url(#mask196)"
  })), _use198 || (_use198 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface598",
    mask: "url(#mask197)"
  })), _use199 || (_use199 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface601",
    mask: "url(#mask198)"
  })), _use200 || (_use200 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface604",
    mask: "url(#mask199)"
  })), _use201 || (_use201 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface607",
    mask: "url(#mask200)"
  })), _use202 || (_use202 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface610",
    mask: "url(#mask201)"
  })), _use203 || (_use203 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface613",
    mask: "url(#mask202)"
  })), _use204 || (_use204 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface616",
    mask: "url(#mask203)"
  })), _use205 || (_use205 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface619",
    mask: "url(#mask204)"
  })), _use206 || (_use206 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface622",
    mask: "url(#mask205)"
  })), _use207 || (_use207 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface625",
    mask: "url(#mask206)"
  })), _use208 || (_use208 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface628",
    mask: "url(#mask207)"
  })), _use209 || (_use209 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface631",
    mask: "url(#mask208)"
  })), _use210 || (_use210 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface634",
    mask: "url(#mask209)"
  })), _use211 || (_use211 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface637",
    mask: "url(#mask210)"
  })), _use212 || (_use212 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface640",
    mask: "url(#mask211)"
  })), _use213 || (_use213 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface643",
    mask: "url(#mask212)"
  })), _use214 || (_use214 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface646",
    mask: "url(#mask213)"
  })), _use215 || (_use215 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface649",
    mask: "url(#mask214)"
  })), _use216 || (_use216 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface652",
    mask: "url(#mask215)"
  })), _use217 || (_use217 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface655",
    mask: "url(#mask216)"
  })), _use218 || (_use218 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface658",
    mask: "url(#mask217)"
  })), _use219 || (_use219 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface661",
    mask: "url(#mask218)"
  })), _use220 || (_use220 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface664",
    mask: "url(#mask219)"
  })), _use221 || (_use221 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface667",
    mask: "url(#mask220)"
  })), _use222 || (_use222 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface670",
    mask: "url(#mask221)"
  })), _use223 || (_use223 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface673",
    mask: "url(#mask222)"
  })), _use224 || (_use224 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface676",
    mask: "url(#mask223)"
  })), _use225 || (_use225 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface679",
    mask: "url(#mask224)"
  })), _use226 || (_use226 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface682",
    mask: "url(#mask225)"
  })), _use227 || (_use227 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface685",
    mask: "url(#mask226)"
  })), _use228 || (_use228 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface688",
    mask: "url(#mask227)"
  })), _use229 || (_use229 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface691",
    mask: "url(#mask228)"
  })), _use230 || (_use230 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface694",
    mask: "url(#mask229)"
  })), _use231 || (_use231 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface697",
    mask: "url(#mask230)"
  })), _use232 || (_use232 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface700",
    mask: "url(#mask231)"
  })), _use233 || (_use233 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface703",
    mask: "url(#mask232)"
  })), _use234 || (_use234 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface706",
    mask: "url(#mask233)"
  })), _use235 || (_use235 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface709",
    mask: "url(#mask234)"
  })), _use236 || (_use236 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface712",
    mask: "url(#mask235)"
  })), _use237 || (_use237 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface715",
    mask: "url(#mask236)"
  })), _use238 || (_use238 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface718",
    mask: "url(#mask237)"
  })), _use239 || (_use239 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface721",
    mask: "url(#mask238)"
  })), _use240 || (_use240 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface724",
    mask: "url(#mask239)"
  })), _use241 || (_use241 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface727",
    mask: "url(#mask240)"
  })), _use242 || (_use242 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface730",
    mask: "url(#mask241)"
  })), _use243 || (_use243 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface733",
    mask: "url(#mask242)"
  })), _use244 || (_use244 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface736",
    mask: "url(#mask243)"
  })), _use245 || (_use245 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface739",
    mask: "url(#mask244)"
  })), _use246 || (_use246 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface742",
    mask: "url(#mask245)"
  })), _use247 || (_use247 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface745",
    mask: "url(#mask246)"
  })), _use248 || (_use248 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface748",
    mask: "url(#mask247)"
  })), _use249 || (_use249 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface751",
    mask: "url(#mask248)"
  })), _use250 || (_use250 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface754",
    mask: "url(#mask249)"
  })), _use251 || (_use251 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface757",
    mask: "url(#mask250)"
  })), _use252 || (_use252 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface760",
    mask: "url(#mask251)"
  })), _use253 || (_use253 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface763",
    mask: "url(#mask252)"
  })), _use254 || (_use254 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface766",
    mask: "url(#mask253)"
  })), _use255 || (_use255 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface769",
    mask: "url(#mask254)"
  })), _use256 || (_use256 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface772",
    mask: "url(#mask255)"
  })), _use257 || (_use257 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface775",
    mask: "url(#mask256)"
  })), _use258 || (_use258 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface778",
    mask: "url(#mask257)"
  })), _use259 || (_use259 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface781",
    mask: "url(#mask258)"
  })), _use260 || (_use260 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface784",
    mask: "url(#mask259)"
  })), _use261 || (_use261 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface787",
    mask: "url(#mask260)"
  })), _use262 || (_use262 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface790",
    mask: "url(#mask261)"
  })), _use263 || (_use263 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface793",
    mask: "url(#mask262)"
  })), _use264 || (_use264 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface796",
    mask: "url(#mask263)"
  })), _use265 || (_use265 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface799",
    mask: "url(#mask264)"
  })), _use266 || (_use266 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface802",
    mask: "url(#mask265)"
  })), _use267 || (_use267 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface805",
    mask: "url(#mask266)"
  })), _use268 || (_use268 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface808",
    mask: "url(#mask267)"
  })), _use269 || (_use269 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface811",
    mask: "url(#mask268)"
  })), _use270 || (_use270 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface814",
    mask: "url(#mask269)"
  })), _use271 || (_use271 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface817",
    mask: "url(#mask270)"
  })), _use272 || (_use272 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface820",
    mask: "url(#mask271)"
  })), _use273 || (_use273 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface823",
    mask: "url(#mask272)"
  })), _use274 || (_use274 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface826",
    mask: "url(#mask273)"
  })), _use275 || (_use275 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface829",
    mask: "url(#mask274)"
  })), _use276 || (_use276 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface832",
    mask: "url(#mask275)"
  })), _use277 || (_use277 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface835",
    mask: "url(#mask276)"
  })), _use278 || (_use278 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface838",
    mask: "url(#mask277)"
  })), _use279 || (_use279 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface841",
    mask: "url(#mask278)"
  })), _use280 || (_use280 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface844",
    mask: "url(#mask279)"
  })), _use281 || (_use281 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface847",
    mask: "url(#mask280)"
  })), _use282 || (_use282 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface850",
    mask: "url(#mask281)"
  })), _use283 || (_use283 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface853",
    mask: "url(#mask282)"
  })), _use284 || (_use284 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface856",
    mask: "url(#mask283)"
  })), _use285 || (_use285 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface859",
    mask: "url(#mask284)"
  })), _use286 || (_use286 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface862",
    mask: "url(#mask285)"
  })), _use287 || (_use287 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface865",
    mask: "url(#mask286)"
  })), _use288 || (_use288 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface868",
    mask: "url(#mask287)"
  })), _use289 || (_use289 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface871",
    mask: "url(#mask288)"
  })), _use290 || (_use290 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface874",
    mask: "url(#mask289)"
  })), _use291 || (_use291 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface877",
    mask: "url(#mask290)"
  })), _use292 || (_use292 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface880",
    mask: "url(#mask291)"
  })), _use293 || (_use293 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface883",
    mask: "url(#mask292)"
  })), _use294 || (_use294 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface886",
    mask: "url(#mask293)"
  })), _use295 || (_use295 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface889",
    mask: "url(#mask294)"
  })), _use296 || (_use296 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface892",
    mask: "url(#mask295)"
  })), _use297 || (_use297 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface895",
    mask: "url(#mask296)"
  })), _use298 || (_use298 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface898",
    mask: "url(#mask297)"
  })), _use299 || (_use299 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface901",
    mask: "url(#mask298)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 212.481261 81.000732 L 208.485734 86.004639 Z M 212.481261 81.000732 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 333.514323 83.01123 L 334.501981 85.021729 Z M 333.514323 83.01123 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 338.497509 88.998047 L 336.522192 91.991455 Z M 338.497509 88.998047 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 325.478374 102.982178 L 323.503057 106.020264 Z M 325.478374 102.982178 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 391.516814 107.003174 L 390.484262 109.013672 Z M 391.516814 107.003174 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 388.508945 109.996582 L 387.521286 112.00708 Z M 388.508945 109.996582 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 313.491791 115.983398 L 312.504133 117.993896 Z M 313.491791 115.983398 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 160.494509 120.987305 L 162.514719 123.980713 Z M 160.494509 120.987305 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 164.490036 125.008301 L 165.477695 127.018799 Z M 164.490036 125.008301 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 239.50719 177.996094 L 240.494848 180.006592 Z M 239.50719 177.996094 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 242.515059 180.989502 L 243.502717 183 Z M 242.515059 180.989502 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 392.504472 182.01709 L 393.492131 183.98291 Z M 392.504472 182.01709 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 10.505095 195.018311 L 11.492754 196.984131 Z M 10.505095 195.018311 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 337.509851 195.018311 L 339.978997 198.503174 L 338.991338 198.503174 Z M 337.509851 195.018311 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 353.491961 200.022217 L 354.47962 201.988037 Z M 353.491961 200.022217 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 206.510417 201.988037 L 207.498075 203.998535 Z M 206.510417 201.988037 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 164.490036 204.981445 L 163.502378 206.991943 Z M 164.490036 204.981445 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 212.481261 208.019531 L 213.513813 209.985352 Z M 212.481261 208.019531 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 623.481884 208.019531 L 620.518909 211.99585 Z M 623.481884 208.019531 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 158.519192 211.012939 L 157.486639 212.97876 Z M 158.519192 211.012939 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 532.48262 211.99585 L 537.5107 217.982666 Z M 532.48262 211.99585 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 617.511039 214.006348 L 616.478487 216.016846 Z M 617.511039 214.006348 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 571.495131 303.004395 L 589.991282 303.49585 L 571.495131 303.987305 Z M 571.495131 303.004395 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 564.491735 303.987305 L 567.005774 304.47876 L 564.491735 305.014893 Z M 564.491735 303.987305 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 595.513191 303.987305 L 597.982337 304.47876 L 595.513191 305.014893 Z M 595.513191 303.987305 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 601.484035 305.014893 L 603.998075 305.506348 L 601.484035 305.997803 Z M 601.484035 305.014893 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 136.521343 305.997803 L 137.015172 491.008301 L 214.007643 491.499756 L 137.509001 491.991211 L 135.98262 490.516846 Z M 136.521343 305.997803 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 215.48913 305.997803 L 221.011039 306.489258 L 215.48913 306.980713 Z M 215.48913 305.997803 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 328.486243 305.997803 L 328.980072 491.008301 L 363.503227 491.008301 L 363.997056 490.516846 L 363.997056 368.501953 L 365.478544 368.010498 L 366.511096 370.020996 L 364.984715 369.484863 L 364.984715 490.516846 L 363.503227 491.991211 L 329.518795 491.991211 L 327.992414 490.516846 Z M 328.486243 305.997803 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 361.483016 305.997803 L 363.503227 308.991211 Z M 361.483016 305.997803 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 490.507133 305.997803 L 491.000962 490.516846 L 489.519475 491.991211 L 461.505888 491.991211 L 461.505888 491.008301 L 489.519475 491.008301 L 490.013304 490.516846 Z M 490.507133 305.997803 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 224.512738 306.980713 L 226.981884 307.516846 L 224.512738 308.008301 Z M 224.512738 306.980713 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 364.490885 310.018799 L 366.511096 313.012207 Z M 364.490885 310.018799 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 540.518569 313.012207 L 539.486017 314.978027 Z M 540.518569 313.012207 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 625.502095 313.012207 L 629.991452 315.51416 L 628.509964 314.978027 C 625.95103 314.799316 624.963372 314.12915 625.502095 313.012207 Z M 625.502095 313.012207 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 251.493773 314.978027 L 259.978657 319.490479 L 258.497169 318.999023 L 251.493773 316.005615 Z M 251.493773 314.978027 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 368.486413 314.978027 L 370.506624 318.016113 Z M 368.486413 314.978027 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 537.5107 314.978027 L 535.490489 318.016113 Z M 537.5107 314.978027 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 635.513361 318.016113 L 636.501019 319.981934 Z M 635.513361 318.016113 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 371.494282 318.999023 L 373.514493 321.992432 Z M 371.494282 318.999023 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 532.48262 318.999023 L 528.487092 324.00293 Z M 532.48262 318.999023 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 638.52123 319.981934 L 639.508888 321.992432 Z M 638.52123 319.981934 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 263.480356 321.009521 L 264.512908 323.02002 Z M 263.480356 321.009521 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 641.484205 321.992432 L 643.504416 324.98584 Z M 641.484205 321.992432 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 266.488225 323.02002 L 268.508435 326.013428 Z M 266.488225 323.02002 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 375.48981 324.00293 L 377.51002 326.996338 Z M 375.48981 324.00293 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 645.479733 324.98584 L 647.499943 327.979248 Z M 645.479733 324.98584 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 270.483752 326.013428 L 273.491621 329.989746 Z M 270.483752 326.013428 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 526.511775 326.013428 L 525.479223 327.979248 Z M 526.511775 326.013428 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 378.497679 327.979248 L 380.517889 331.017334 Z M 378.497679 327.979248 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 524.491565 329.006836 L 523.503906 331.017334 Z M 524.491565 329.006836 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 647.499943 329.006836 L 646.512285 331.017334 Z M 647.499943 329.006836 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 276.49949 331.017334 L 281.482677 337.00415 Z M 276.49949 331.017334 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 381.505548 332.000244 L 383.480865 334.993652 Z M 381.505548 332.000244 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 522.516248 332.000244 L 522.022418 333.519287 L 520.496037 337.00415 L 520.002208 335.485107 Z M 522.516248 332.000244 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 645.479733 332.000244 L 643.504416 334.993652 Z M 645.479733 332.000244 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 573.515342 336.02124 L 585.995754 336.512695 L 573.515342 337.00415 Z M 573.515342 336.02124 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 642.516757 336.02124 L 641.484205 337.987061 Z M 642.516757 336.02124 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 385.501076 337.00415 L 387.521286 339.997559 Z M 385.501076 337.00415 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 589.497452 337.00415 L 592.011492 337.495605 L 589.497452 337.987061 Z M 589.497452 337.00415 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 564.491735 337.987061 L 566.018116 338.478516 L 561.483865 340.980469 L 562.516418 339.014648 Z M 564.491735 337.987061 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 173.513644 339.014648 L 211.987432 339.506104 L 173.513644 339.997559 Z M 173.513644 339.014648 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 283.502887 339.014648 L 286.510756 342.990967 Z M 283.502887 339.014648 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 640.496547 339.014648 L 639.508888 340.980469 Z M 640.496547 339.014648 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 217.509341 339.997559 L 219.978487 340.489014 L 217.509341 340.980469 Z M 217.509341 339.997559 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 388.508945 340.980469 L 390.484262 344.018555 Z M 388.508945 340.980469 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 559.508548 340.980469 L 554.480469 347.011963 Z M 559.508548 340.980469 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 637.488678 342.990967 L 636.501019 345.001465 Z M 637.488678 342.990967 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 287.498415 344.018555 L 288.486073 345.984375 Z M 287.498415 344.018555 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 392.504472 345.984375 L 394.479789 348.977783 Z M 392.504472 345.984375 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 635.513361 345.984375 L 634.480808 347.994873 Z M 635.513361 345.984375 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 238.519531 347.011963 L 242.02123 349.513916 L 240.494848 348.977783 Z M 238.519531 347.011963 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 289.518625 347.011963 L 290.506284 348.977783 Z M 289.518625 347.011963 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 616.478487 347.011963 L 617.511039 348.977783 Z M 616.478487 347.011963 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 619.486356 348.977783 L 620.518909 350.988281 Z M 619.486356 348.977783 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 633.49315 348.977783 L 631.517833 352.015869 Z M 633.49315 348.977783 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 243.502717 350.005371 L 246.510587 353.981689 Z M 243.502717 350.005371 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 291.493942 350.005371 L 292.481601 352.015869 Z M 291.493942 350.005371 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 395.512341 350.005371 L 397.487659 352.998779 Z M 395.512341 350.005371 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 622.494226 350.988281 L 623.481884 352.998779 Z M 622.494226 350.988281 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 625.502095 352.998779 L 626.489753 355.009277 Z M 625.502095 352.998779 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 630.485281 352.998779 L 628.509964 355.992188 Z M 630.485281 352.998779 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 398.520211 353.981689 L 400.495528 357.019775 Z M 398.520211 353.981689 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 515.512851 355.992188 L 516.00668 360.504639 L 515.019022 360.504639 Z M 515.512851 355.992188 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 552.505152 358.002686 L 552.998981 360.504639 L 552.011322 360.504639 Z M 552.505152 358.002686 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 252.481431 358.985596 L 254.501642 361.979004 Z M 252.481431 358.985596 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 402.515738 358.985596 L 404.491055 361.979004 Z M 402.515738 358.985596 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 405.478714 363.006592 L 407.498924 366 Z M 405.478714 363.006592 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 554.480469 365.01709 L 555.513021 366.98291 Z M 554.480469 365.01709 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 257.509511 366 L 258.497169 368.010498 Z M 257.509511 366 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 516.50051 366.98291 L 516.994339 369.484863 L 516.00668 369.484863 Z M 516.50051 366.98291 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 409.519135 368.010498 L 411.494452 371.003906 Z M 409.519135 368.010498 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 557.488338 368.010498 L 559.508548 371.003906 Z M 557.488338 368.010498 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 367.498755 371.003906 L 369.518965 373.997314 Z M 367.498755 371.003906 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 412.482111 371.986816 L 414.502321 374.980225 Z M 412.482111 371.986816 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 370.506624 374.980225 L 372.481941 378.018311 Z M 370.506624 374.980225 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 302.492867 376.007812 L 302.986696 378.509766 L 301.999038 378.509766 Z M 302.492867 376.007812 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 415.48998 376.007812 L 418.497849 379.984131 Z M 415.48998 376.007812 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 374.502151 379.984131 L 376.522362 383.022217 Z M 374.502151 379.984131 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 303.480525 381.011719 L 304.019248 384.496582 L 302.986696 384.496582 Z M 303.480525 381.011719 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 419.485507 381.011719 L 421.505718 384.005127 Z M 419.485507 381.011719 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 520.496037 381.011719 L 522.022418 383.513672 L 520.002208 382.486084 Z M 520.496037 381.011719 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 590.485111 381.011719 L 592.999151 381.503174 L 590.485111 381.994629 Z M 590.485111 381.011719 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 377.51002 384.005127 L 379.485337 386.998535 Z M 377.51002 384.005127 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 422.493376 384.988037 L 424.513587 387.981445 Z M 422.493376 384.988037 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 265.500566 386.998535 L 265.994395 389.500488 L 265.006737 389.500488 Z M 265.500566 386.998535 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 523.503906 386.998535 L 525.479223 389.991943 Z M 523.503906 386.998535 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 304.513077 389.009033 L 305.006907 407.505615 L 304.019248 407.505615 Z M 304.513077 389.009033 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 381.505548 389.009033 L 383.480865 392.002441 Z M 381.505548 389.009033 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 426.488904 389.991943 L 428.509115 392.985352 Z M 426.488904 389.991943 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 384.513417 392.985352 L 386.488734 395.97876 Z M 384.513417 392.985352 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 429.496773 394.012939 L 431.516984 397.006348 Z M 429.496773 394.012939 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 628.509964 394.012939 L 629.497622 395.97876 Z M 628.509964 394.012939 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 532.48262 395.97876 L 534.502831 399.016846 Z M 532.48262 395.97876 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 631.517833 395.97876 L 632.505491 397.989258 Z M 631.517833 395.97876 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 387.521286 397.006348 L 390.484262 400.982666 Z M 387.521286 397.006348 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 634.480808 397.989258 L 636.501019 400.982666 Z M 634.480808 397.989258 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 433.492301 399.016846 L 435.512511 402.010254 Z M 433.492301 399.016846 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 536.478148 399.016846 L 537.5107 400.982666 Z M 536.478148 399.016846 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 391.516814 402.010254 L 393.492131 405.003662 Z M 391.516814 402.010254 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 436.50017 402.993164 L 438.52038 405.986572 Z M 436.50017 402.993164 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 394.479789 405.986572 L 396.5 408.97998 Z M 394.479789 405.986572 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 265.500566 407.01416 L 265.994395 410.499023 L 265.006737 410.499023 Z M 265.500566 407.01416 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 439.508039 407.01416 L 441.483356 410.007568 Z M 439.508039 407.01416 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 643.504416 407.01416 L 645.479733 410.007568 Z M 643.504416 407.01416 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 398.520211 410.990479 L 400.495528 413.983887 Z M 398.520211 410.990479 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 303.480525 412.018066 L 304.019248 415.50293 L 302.986696 415.50293 Z M 303.480525 412.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 443.503567 412.018066 L 445.478884 415.011475 Z M 443.503567 412.018066 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 647.499943 413.000977 L 648.981431 415.50293 L 647.993773 415.50293 Z M 647.499943 413.000977 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 401.483186 415.011475 L 403.503397 418.004883 Z M 401.483186 415.011475 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 446.511436 415.994385 L 448.486753 418.987793 Z M 446.511436 415.994385 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 405.478714 420.015381 L 407.498924 423.008789 Z M 405.478714 420.015381 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 450.506963 420.998291 L 452.48228 423.991699 Z M 450.506963 420.998291 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 602.516587 421.981201 L 608.981261 425.510742 L 607.499774 425.019287 L 602.516587 423.008789 Z M 602.516587 421.981201 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 261.505038 423.008789 L 261.998868 424.483154 L 257.509511 431.989014 L 258.00334 430.514648 Z M 261.505038 423.008789 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 408.486583 423.991699 L 410.506793 426.985107 Z M 408.486583 423.991699 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 610.507643 426.002197 L 614.50317 431.006104 Z M 610.507643 426.002197 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 652.48313 426.002197 L 653.021852 428.50415 L 651.9893 428.50415 Z M 652.48313 426.002197 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 411.494452 428.012695 L 413.514663 431.006104 Z M 411.494452 428.012695 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 256.521852 433.016602 L 255.4893 434.982422 Z M 256.521852 433.016602 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 415.48998 433.016602 L 417.51019 436.01001 Z M 415.48998 433.016602 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 616.478487 434.982422 L 617.01721 437.484375 L 615.984658 437.484375 Z M 616.478487 434.982422 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 653.515682 434.982422 L 654.009511 439.494873 L 653.021852 439.494873 Z M 653.515682 434.982422 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 254.501642 436.01001 L 245.478034 446.017822 Z M 254.501642 436.01001 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 418.497849 436.99292 L 420.518059 439.986328 Z M 418.497849 436.99292 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 529.519644 436.99292 L 526.511775 441.013916 Z M 529.519644 436.99292 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 531.494962 436.99292 L 535.490489 441.996826 Z M 531.494962 436.99292 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 422.493376 441.996826 L 424.513587 444.990234 Z M 422.493376 441.996826 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 537.5107 441.996826 L 539.486017 444.990234 Z M 537.5107 441.996826 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 524.491565 442.979736 L 521.483696 447.000732 Z M 524.491565 442.979736 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 616.478487 442.979736 L 617.01721 445.481689 L 615.984658 445.481689 Z M 616.478487 442.979736 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 292.481601 444.990234 L 291.987772 446.509277 L 290.506284 449.01123 L 291.000113 447.492188 Z M 292.481601 444.990234 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 541.506227 444.990234 L 542.493886 447.000732 Z M 541.506227 444.990234 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 243.502717 446.017822 L 241.482507 449.01123 L 239.50719 449.994141 L 240.494848 447.983643 Z M 243.502717 446.017822 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 425.501245 446.017822 L 427.521456 449.01123 Z M 425.501245 446.017822 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 652.48313 446.017822 L 653.021852 448.519775 L 651.9893 448.519775 Z M 652.48313 446.017822 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 544.514096 447.000732 L 545.501755 449.01123 Z M 544.514096 447.000732 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 615.490829 447.000732 L 615.984658 448.519775 L 614.009341 449.502686 Z M 615.490829 447.000732 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 519.508379 449.01123 L 515.512851 454.015137 Z M 519.508379 449.01123 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 547.521966 449.01123 L 548.509624 451.021729 Z M 547.521966 449.01123 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 289.518625 449.994141 L 287.498415 452.987549 Z M 289.518625 449.994141 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 428.509115 449.994141 L 431.516984 454.015137 Z M 428.509115 449.994141 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 613.515512 451.021729 L 609.519984 455.980957 Z M 613.515512 451.021729 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 286.510756 454.015137 L 284.490546 457.008545 Z M 286.510756 454.015137 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 432.504642 454.998047 L 434.479959 457.991455 Z M 432.504642 454.998047 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 513.49264 455.980957 L 510.484771 460.001953 Z M 513.49264 455.980957 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 211.493603 457.008545 L 215.98296 457.5 L 211.493603 457.991455 Z M 211.493603 457.008545 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 282.515229 459.019043 L 275.511832 467.016357 Z M 282.515229 459.019043 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 435.512511 459.019043 L 437.487828 462.012451 Z M 435.512511 459.019043 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 570.507473 459.019043 L 573.021513 459.510498 L 570.507473 460.001953 Z M 570.507473 459.019043 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 576.478317 460.001953 L 581.012568 460.493408 L 576.478317 460.984863 Z M 576.478317 460.001953 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 593.49298 460.001953 L 596.994678 460.493408 L 593.49298 460.984863 Z M 593.49298 460.001953 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 648.487602 460.001953 L 648.981431 461.520996 L 646.512285 465.005859 L 647.006114 463.486816 Z M 648.487602 460.001953 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 508.509454 462.012451 L 512.011153 466.480225 L 508.015625 463.486816 Z M 508.509454 462.012451 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 439.508039 463.978271 L 441.483356 467.016357 Z M 439.508039 463.978271 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 272.503963 467.999268 L 269.496094 472.020264 Z M 272.503963 467.999268 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 442.515908 467.999268 L 444.491225 470.992676 Z M 442.515908 467.999268 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 514.480299 467.999268 L 516.50051 470.992676 Z M 514.480299 467.999268 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 644.492074 467.999268 L 642.516757 470.992676 Z M 644.492074 467.999268 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 518.52072 470.992676 L 520.496037 473.986084 Z M 518.52072 470.992676 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 267.520777 472.020264 L 266.488225 473.986084 Z M 267.520777 472.020264 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 641.484205 472.020264 L 634.480808 480.017578 Z M 641.484205 472.020264 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 446.511436 473.003174 L 448.486753 475.996582 Z M 446.511436 473.003174 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 264.512908 473.986084 L 263.480356 475.996582 Z M 264.512908 473.986084 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 522.516248 473.986084 L 523.503906 475.996582 Z M 522.516248 473.986084 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 261.505038 475.996582 L 260.51738 478.00708 L 258.497169 478.98999 L 259.484828 476.979492 Z M 261.505038 475.996582 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 525.479223 475.996582 L 526.511775 478.00708 Z M 525.479223 475.996582 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 449.519305 476.979492 L 451.494622 480.017578 Z M 449.519305 476.979492 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 530.507303 478.98999 L 534.009001 481.491943 L 532.48262 481.000488 Z M 530.507303 478.98999 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 632.505491 480.017578 L 630.485281 483.010986 Z M 632.505491 480.017578 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 452.48228 481.000488 L 454.502491 483.993896 Z M 452.48228 481.000488 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 537.5107 483.010986 L 541.012398 484.485352 L 539.486017 485.021484 Z M 537.5107 483.010986 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 626.489753 483.993896 L 625.502095 486.004395 L 620.518909 488.014893 L 620.518909 486.987305 Z M 626.489753 483.993896 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 456.477808 486.004395 L 458.498019 488.997803 Z M 456.477808 486.004395 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 231.516135 488.014893 L 233.985281 488.506348 L 231.516135 488.997803 Z M 231.516135 488.014893 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 226.488055 488.997803 L 229.002095 489.489258 L 226.488055 489.980713 Z M 226.488055 488.997803 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 220.51721 489.980713 L 222.986356 490.516846 L 220.51721 491.008301 Z M 220.51721 489.980713 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 566.511945 491.991211 L 568.981091 492.482666 L 566.511945 493.018799 Z M 566.511945 491.991211 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 603.504246 491.991211 L 606.018286 492.482666 L 603.504246 493.018799 Z M 603.504246 491.991211 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 573.515342 493.018799 L 578.004699 493.510254 L 573.515342 494.001709 Z M 573.515342 493.018799 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(99.607843%,99.607843%,99.607843%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 595.513191 493.018799 L 600.002548 493.510254 L 595.513191 494.001709 Z M 595.513191 493.018799 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 84.489697 7.014404 L 86.509907 7.997314 L 87.497566 7.014404 L 102.492018 7.014404 L 111.515625 8.980225 L 118.519022 8.980225 L 130.505605 12.018311 L 143.479846 17.022217 C 154.882812 21.936768 164.714504 28.415039 173.019814 36.501709 L 151.021966 67.999512 L 136.521343 59.019287 L 111.515625 47.983887 L 101.504359 46.018066 L 83.502038 46.018066 L 69.495245 51.021973 L 62.985677 57.500244 L 59.977808 69.518555 L 61.998019 78.498779 L 66.487375 83.994141 L 81.481827 91.991455 L 120.494339 101.999268 L 140.51687 109.013672 L 150.483243 114.017578 L 163.996207 123.980713 L 170.011945 131.486572 L 175.98279 143.504883 L 178.990659 157.489014 L 178.990659 171.517822 L 177.015342 182.508545 L 174.007473 190.505859 C 170.3262 198.503174 165.477695 205.338867 159.50685 211.012939 C 143.614527 226.114014 118.967957 232.458252 85.522249 230.000977 L 84.489697 229.018066 L 73.490772 227.990479 L 49.517606 221.020752 L 33.490602 212.97876 L 11.986583 198.011719 L 10.505095 195.018311 C 9.023607 195.554443 8.529778 195.018311 8.978714 193.499268 L 15.982111 183.98291 C 17.777853 184.742432 18.451257 184.250977 18.002321 182.508545 L 34.478261 162.984375 L 37.979959 164.994873 C 37.261662 166.781982 37.755491 167.452148 39.506341 167.005371 C 48.30548 175.538818 58.945256 182.195801 71.515455 187.020996 L 86.509907 190.997314 L 106.487545 191.980225 L 120.494339 188.986816 L 130.999434 183 L 135.98262 173.483643 L 135.98262 161.51001 C 134.994962 157.17627 132.84007 154.00415 129.517946 151.993652 L 117.48647 144.979248 L 105.499887 141.00293 L 78.518852 135.016113 L 54.500793 127.018799 C 44.489527 122.997803 36.318897 117.14502 29.988904 109.505127 C 24.871037 103.652344 21.189764 96.280518 18.98998 87.479004 C 19.887851 84.306885 19.528702 82.296387 18.002321 81.492188 L 18.002321 62.50415 C 20.87551 46.688232 27.385077 34.535889 37.48613 26.002441 L 40.493999 23.991943 C 45.297611 19.12207 51.313349 15.458496 58.49632 13.001221 L 67.519928 10.007812 Z M 84.489697 7.014404 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 737.511549 10.007812 L 738.005378 62.012695 L 781.013417 62.012695 L 781.013417 99.005859 L 739.486866 99.005859 L 738.005378 100.480225 L 738.005378 178.487549 L 739.980695 185.501953 L 743.482394 188.986816 C 746.714731 191.801514 751.697917 192.784424 758.521739 191.980225 L 769.520663 190.014404 L 778.499377 185.010498 L 781.013417 185.010498 L 781.013417 220.484619 L 779.487036 221.020752 L 772.483639 224.99707 L 760.497056 229.018066 C 757.354506 228.213867 755.379189 228.526611 754.481318 230.000977 L 735.491338 230.000977 L 725.480072 227.990479 L 714.481148 222.986572 L 704.020947 213.514893 C 700.204993 207.617432 697.511379 200.647705 695.984998 192.516357 L 695.984998 100.480225 L 694.50351 99.005859 L 675.019701 99.005859 L 675.019701 62.012695 L 695.984998 62.012695 L 695.984998 27.521484 L 697.511379 26.985352 Z M 737.511549 10.007812 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 260.51738 59.019287 L 283.502887 59.019287 L 284.490546 60.002197 L 295.48947 60.985107 L 313.491791 67.999512 L 333.020494 81.983643 L 338.00368 89.489502 L 312.504133 117.010986 C 305.68031 109.460449 297.375 103.473633 287.498415 99.005859 C 281.168422 96.325195 272.818218 95.655029 262.492697 96.995361 C 251.763134 99.58667 243.592505 104.769287 237.980808 112.498535 L 229.002095 130.503662 C 229.855072 133.720459 229.540817 135.686279 228.014436 136.490479 L 228.014436 153.512695 C 230.483582 166.022461 235.646343 175.851562 243.502717 183 L 259.484828 191.980225 L 263.480356 193.007812 L 283.502887 193.007812 L 293.514153 188.986816 L 305.994565 180.989502 C 305.276268 179.202393 305.770097 178.532227 307.520947 178.979004 L 314.47945 172.992188 L 338.991338 197.520264 L 338.991338 199.486084 L 328.486243 209.985352 L 327.004755 209.985352 C 327.723053 211.817139 327.229223 212.487305 325.478374 211.99585 C 318.879019 218.742188 310.573709 223.746094 300.51755 227.007568 L 281.482677 230.983887 L 262.492697 230.983887 L 254.501642 230.000977 L 237.486979 224.99707 C 225.769758 220.08252 215.938066 213.246826 207.991904 204.48999 C 193.401495 190.773926 185.724694 170.088135 185.006397 142.521973 L 185.006397 140.511475 L 185.994056 130.503662 L 192.009794 110.488037 L 197.980639 98.514404 L 207.004246 86.004639 L 227.520607 70.01001 L 237.486979 65.006104 Z M 260.51738 59.019287 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 410.506793 59.019287 L 433.492301 59.019287 L 456.477808 65.006104 C 470.080559 70.724854 481.259058 78.900879 490.013304 89.489502 C 495.355639 95.520996 499.665421 102.490723 502.987545 110.488037 L 508.015625 126.482666 L 509.990942 145.515381 L 509.003284 146.498291 L 508.015625 162.49292 L 502.987545 178.487549 C 497.061594 191.578125 488.890965 202.390137 478.52055 211.012939 L 467.521626 219.010254 L 446.511436 227.990479 L 430.484432 230.983887 L 411.494452 230.983887 L 396.5 227.990479 L 382.493207 222.986572 L 363.009398 211.012939 C 363.727695 209.181152 363.233865 208.555664 361.483016 209.002441 C 347.117074 197.073486 337.913893 179.917236 334.008152 157.489014 L 334.008152 133.49707 L 339.978997 111.515625 C 346.219203 98.022949 354.704087 86.853516 365.478544 78.007324 L 387.521286 65.006104 Z M 411.988281 96.995361 C 403.997226 99.005859 397.352978 102.312012 392.010643 107.003174 C 385.994905 111.649658 381.685122 117.993896 378.991508 125.991211 L 377.016191 136.981934 L 375.983639 140.02002 L 375.983639 149.983154 L 378.00385 161.018555 C 380.65257 167.675537 384.019588 173.662354 388.015115 178.979004 C 392.684047 184.340332 398.654891 188.31665 406.017437 190.997314 L 411.988281 193.007812 L 425.995075 193.007812 L 426.982733 193.990723 L 439.01421 190.997314 L 451.000793 183.98291 L 461.012058 172.009277 L 465.007586 162.001465 L 466.982903 151.993652 L 466.982903 138.992432 L 465.007586 130.012207 L 457.016531 114.017578 C 452.3476 107.315918 446.017606 102.312012 437.981658 99.005859 L 432.010813 96.995361 Z M 411.988281 96.995361 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 517.981997 62.012695 L 560.002378 62.012695 L 560.002378 161.51001 L 563.010247 174.51123 L 571.495131 185.993408 L 582.494056 190.997314 L 599.508718 190.997314 C 607.634454 188.808105 613.784873 184.653076 618.004869 178.487549 L 622.000396 170.490234 L 624.020607 160.482422 L 624.020607 62.012695 L 665.502264 62.012695 L 665.996094 62.50415 L 665.996094 227.007568 L 624.020607 227.007568 L 624.020607 208.510986 L 619.980186 211.504395 L 618.498698 214.006348 L 615.984658 215.480713 C 616.523381 217.044434 616.029552 217.535889 614.50317 216.999756 C 609.295516 222.807861 602.29212 226.78418 593.49298 229.018066 L 582.494056 230.000977 L 581.506397 230.983887 L 571.495131 230.983887 L 570.507473 230.000977 L 559.508548 229.018066 L 544.514096 222.986572 L 530.013474 209.493896 L 523.010077 197.520264 L 517.981997 179.515137 Z M 517.981997 62.012695 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 567.499604 303.987305 L 594.480639 303.987305 L 609.519984 306.980713 C 624.963372 311.537842 637.802933 318.686279 647.993773 328.515381 L 628.509964 355.009277 L 604.491904 340.980469 L 585.501925 336.02124 L 573.515342 336.02124 L 562.516418 339.014648 L 553.986639 346.520508 C 551.786855 349.647949 551.113451 354.294434 552.011322 360.504639 C 553.178555 365.285156 555.692595 368.814697 559.508548 371.003906 L 579.486187 379.001221 L 594.480639 381.994629 L 621.506567 391.019531 C 629.946558 394.861816 637.129529 400.044434 643.010587 406.478027 L 651.9893 424.483154 L 653.021852 429.487061 L 653.021852 445.481689 C 650.328238 460.85083 643.818671 472.333008 633.49315 480.017578 C 620.878057 490.382812 602.561481 495.073975 578.498528 494.001709 L 555.513021 489.980713 L 536.478148 483.010986 C 526.017946 477.783691 516.859658 471.30542 509.003284 463.486816 L 509.003284 461.520996 L 530.507303 436.99292 C 538.677933 445.481689 548.689198 452.138672 560.496207 457.008545 L 576.478317 460.984863 L 596.500849 460.984863 L 609.519984 455.980957 L 614.009341 451.513184 C 617.151891 448.296387 618.139549 442.979736 617.01721 435.518555 C 615.984658 431.184814 613.829767 428.012695 610.507643 426.002197 L 592.505322 418.004883 L 565.479393 412.018066 L 548.509624 405.986572 C 539.441123 402.412354 531.943897 397.229736 526.017946 390.483398 L 516.994339 372.478271 L 516.00668 350.496826 C 518.924762 336.42334 525.120075 325.611328 534.502831 318.016113 C 543.032609 310.867676 554.031533 306.221191 567.499604 303.987305 Z M 567.499604 303.987305 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 137.015172 305.997803 L 214.501472 305.997803 L 215.48913 306.980713 L 229.495924 308.008301 C 252.301857 313.190918 270.124604 323.377441 283.009058 338.478516 C 291.673517 348.173584 298.00351 360.147217 301.999038 374.48877 L 304.019248 385.479492 L 304.019248 411.481934 C 299.754359 436.233398 289.563519 455.087402 273.491621 467.999268 C 261.235677 479.079346 245.253567 486.406494 225.500396 489.980713 C 222.357846 489.221191 220.382529 489.533936 219.484658 491.008301 L 137.015172 491.008301 Z M 173.019814 339.014648 L 173.019814 457.991455 L 215.98296 457.991455 C 216.656363 456.651123 218.676574 456.338379 221.998698 457.008545 C 231.33656 454.998047 239.327615 451.334473 246.016757 446.017822 C 256.656533 438.020508 263.345675 426.314941 265.994395 410.990479 L 265.994395 387.981445 L 265.006737 383.022217 C 262.986526 374.354736 259.664402 367.340332 254.995471 361.979004 C 248.351223 352.686035 239.327615 345.984375 228.014436 342.008057 L 211.987432 339.014648 Z M 173.019814 339.014648 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1,
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 328.980072 305.997803 L 360.495358 305.997803 L 363.997056 309.482666 L 453.514832 426.002197 L 454.008662 305.997803 L 489.519475 305.997803 L 490.013304 306.489258 L 490.013304 491.008301 L 460.518229 491.008301 L 458.991848 489.489258 L 365.478544 368.010498 L 363.997056 368.501953 L 363.997056 490.516846 L 363.503227 491.008301 L 328.980072 491.008301 Z M 328.980072 305.997803 ",
    transform: "matrix(0.0870113,0,0,0.0874317,0,0)"
  }), _use300 || (_use300 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface904",
    mask: "url(#mask299)"
  })), _use301 || (_use301 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface907",
    mask: "url(#mask300)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logoMini.b2f26c40a4ccc9b2d2bacbd0471526c5.svg";
export { ForwardRef as ReactComponent };